var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { Helmet } from 'react-helmet';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { useParams, useLocation, useMatch, useNavigate, } from 'react-router-dom';
import isEqual from 'lodash/isEqual';
import produce from 'immer';
import { createStructuredSelector } from 'reselect';
import { ReactFlowProvider } from 'reactflow';
import { logicProperties as getLogicProperties, logicStates, } from '@appspotr/app';
import { resolvePatchesToDelete, buildPatchSelection, resolveEdgeSelection, } from './utils';
import * as actions from './actions';
import * as logicBuilderActions from '../../store/logicBuilder/actions';
import { setCustomLogicSubscription, updateOutputParamSync, } from '../../store/logicBuilder/actions';
import * as platformActions from '../../store/platform/actions';
import { Wrapper } from './styles';
import * as stateActions from '../../store/state/actions';
import { selectState } from '../../store/state/selectors';
import * as variableActions from '../../store/variable/actions';
import * as envActions from '../../store/environment/actions';
import { selectVariable } from '../../store/variable/selectors';
import * as datasetRulesActions from '../../store/rules/actions';
import { selectDatasetNewRuleId, selectDatasetRules, selectDatasetRulesDatasetId, selectDatasetRulesLoading, selectGroupDropdownOptions, } from '../../store/rules/selectors';
import * as globalStorageActions from '../../store/storage/actions';
import { selectStorage } from '../../store/storage/selectors';
import { selectPlatformDomain } from '../../store/platform/selectors';
import { PageContent } from '../../components/Page';
import { PropertiesBar } from '../../components/PropertiesBar';
import toast from '../../components/Toast';
import { PatchProperties, PropertiesMapper, propertyMapper, } from 'components/CommonBuilderProperties';
import selectStructure, { selectCanvasOffset, selectCreatedView, selectFocalPatch, selectGlobalStyles, selectLoaders, selectTempNewPatch, selectViewState, } from './selectors';
import { cleanPortName } from '../../utils/structure';
import { cleanArgName, cleanEdgeArgName, copyPatches, copyPatchSelection, getPatchIdFromName, } from './helpers';
import { loadApps } from '../Root/actions';
import { selectPermissions } from '../../store/permissions/selectors';
import { PATCH_COPY_TYPE } from './constants';
import { selectAllCustomLogics, selectCustomLogicCreateData, selectCustomLogicSubscription, selectOutputParamSync, } from '../../store/logicBuilder/selectors';
import { selectEnvironments } from '../../store/environment/selectors';
import makeSelectStyle from '../StylesPage/selectors';
import { loadSelectedApp } from '../../store/selectedApp/actions';
import { selectSelectedApp } from '../../store/selectedApp/selectors';
import * as viewBuilderActions from './../ViewBuilder/LegacyViewBuilder/actions';
import { CheckboxWrapper, DescriptionText, PageLoaderContainer, } from '../../components/Loaders/styles';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSpinner } from '@fortawesome/pro-regular-svg-icons/faSpinner';
import { CUSTOM_LOGIC_SUBSCRIPTION_TYPE } from '../../store/logicBuilder/models';
import { getPermissionsByTargets } from '../../store/permissions/actions';
import SetEntrypointWarning from './setEntrypointWarning';
import { loadPushTemplates } from '../../store/pushTemplates/actions';
import { makeSelectPushTemplates, makeSelectPushTemplatesAppId, } from '../../store/pushTemplates/selectors';
import { selectPatchesDropDown } from '../../store/pushNotifications/selectors';
import { clearReceiverApps, loadPushReceiverAppsGroups, } from '../../store/pushMultiApps/actions';
import { selectReceiverApps } from '../../store/pushMultiApps/selectors';
import { CommonModal } from '@appspotr/ui-kit';
import { selectSelectedGroup } from '@project/containers/StructureBuilderPage/selectors';
import Graph from './Graph';
import { AddPatchModal } from './AddPatchModal';
var StructureBuilderPageWrapper = function (props) {
    var location = useLocation();
    var params = useParams();
    var navigate = useNavigate();
    var match = useMatch('/organizations/:organizationId/apps/:appId/structure');
    // Deep link to a specific patch, e.g. .../structure/<patchId> — should be
    // treated the same as the bare structure page for focus purposes.
    var matchWithPatch = useMatch('/organizations/:organizationId/apps/:appId/structure/:patchId');
    return (_jsx(ConnectedStructureBuilderPage, __assign({}, props, { location: location, params: params, navigate: navigate, isExact: !!match || !!matchWithPatch })));
};
var StructureBuilderPage = /** @class */ (function (_super) {
    __extends(StructureBuilderPage, _super);
    function StructureBuilderPage(props) {
        var _this = _super.call(this, props) || this;
        _this.handleClick = function (e) {
            var selectedTarget = e === null || e === void 0 ? void 0 : e.target;
            // ⚠️ the following code block of 9 code lines is used to determine that the clicked node element is a child or a nested child of the canvas
            // ⭐️ it was taken from stackoverflow
            var isSelected = false;
            while (selectedTarget) {
                if (selectedTarget.className === 'css-18f0176') {
                    isSelected = true;
                    break;
                }
                else {
                    selectedTarget = selectedTarget.parentNode;
                }
            }
            _this.setState({ canvasSelected: isSelected });
        };
        //check the custom logics inside the selected patches for patch copy
        _this.checkForCustomLogic = function (patches, selectedIds) {
            return patches === null || patches === void 0 ? void 0 : patches.some(function (patch) {
                return ((selectedIds === null || selectedIds === void 0 ? void 0 : selectedIds.includes(patch === null || patch === void 0 ? void 0 : patch.id)) && (patch === null || patch === void 0 ? void 0 : patch.logic) === 'custom_logic');
            });
        };
        //check the custom logics inside the logic group for patch copy
        _this.checkCustomLogicInsideGroups = function (logicGroup, selectedIds) {
            var logicGroupKeys = new Set(Object.keys(logicGroup));
            for (var i = 0; i < selectedIds.length; i++) {
                var selectedId = selectedIds[i];
                if (logicGroupKeys.has(selectedId)) {
                    var patches = logicGroup[selectedId].patches;
                    if (patches.some(function (patch) { return patch.logic === 'custom_logic'; })) {
                        return true;
                    }
                }
            }
            return false;
        };
        _this.handleOnCopy = function (selectedPatches) { return __awaiter(_this, void 0, void 0, function () {
            var successFlag, patchwork, indexedPatches, customLogic, firstLogicPatchId, firstPatchType, firstPatch, groupIds;
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!(selectedPatches === null || selectedPatches === void 0 ? void 0 : selectedPatches.length))
                            return [2 /*return*/];
                        patchwork = this.props.patchwork.patchwork;
                        indexedPatches = patchwork.patches.reduce(function (acc, item) {
                            acc[item.id] = item;
                            return acc;
                        }, {});
                        customLogic = this.checkForCustomLogic(patchwork === null || patchwork === void 0 ? void 0 : patchwork.patches, selectedPatches) ||
                            this.checkCustomLogicInsideGroups(patchwork === null || patchwork === void 0 ? void 0 : patchwork.logicGroups, selectedPatches);
                        firstLogicPatchId = selectedPatches.find(function (sp) {
                            var _a, _b;
                            return ((_a = indexedPatches[sp]) === null || _a === void 0 ? void 0 : _a.type) === 'logic' ||
                                ((_b = indexedPatches[sp]) === null || _b === void 0 ? void 0 : _b.type) === 'logic_group';
                        });
                        firstPatchType = (_a = indexedPatches[selectedPatches[0].id]) === null || _a === void 0 ? void 0 : _a.type;
                        firstPatch = selectedPatches.includes(firstLogicPatchId)
                            ? indexedPatches[firstLogicPatchId]
                            : {
                                id: selectedPatches[0] || '',
                                patchType: firstPatchType || '',
                            };
                        groupIds = [];
                        selectedPatches.forEach(function (patchId) {
                            if (patchwork.logicGroups[patchId]) {
                                groupIds.push(patchId);
                            }
                        });
                        if (!(selectedPatches.length > 0)) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.handleOnBulkCopy(firstPatch, selectedPatches, groupIds, customLogic)];
                    case 1:
                        successFlag = _b.sent();
                        successFlag
                            ? toast.success("Copied the selected items successfully")
                            : toast.error("Failed to copy the selected items");
                        return [3 /*break*/, 3];
                    case 2:
                        if (this.handleOnSingleCopy(indexedPatches[selectedPatches[0]])) {
                            toast.success("Copied the selection successfully");
                        }
                        else {
                            toast.error("Failed to copy the selection");
                        }
                        _b.label = 3;
                    case 3: return [2 /*return*/];
                }
            });
        }); };
        _this.handleOnSingleCopy = function (selectedEntity) { return __awaiter(_this, void 0, void 0, function () {
            var patchwork, appId, id, type;
            return __generator(this, function (_a) {
                patchwork = this.props.patchwork.patchwork;
                appId = this.props.params.appId;
                id = selectedEntity.id, type = selectedEntity.type;
                return [2 /*return*/, copyPatches(appId, patchwork, id, type)];
            });
        }); };
        _this.handleOnBulkCopy = function (firstPatch, patchIds, groupIds, custom) {
            if (custom === void 0) { custom = false; }
            var patchwork = _this.props.patchwork.patchwork;
            var appId = _this.props.params.appId;
            var customLogic = (firstPatch === null || firstPatch === void 0 ? void 0 : firstPatch.customLogic) || custom;
            var patchMap = Object.fromEntries(patchwork.patches.map(function (p) { return [p.id, p]; }));
            var validTypes = new Set(['custom_logic', 'view', 'navigation', 'list']);
            var hasMatch = patchIds.some(function (id) { var _a; return validTypes.has((_a = patchMap[id]) === null || _a === void 0 ? void 0 : _a.type); });
            if ((firstPatch === null || firstPatch === void 0 ? void 0 : firstPatch.id) || (patchIds === null || patchIds === void 0 ? void 0 : patchIds.length) || (groupIds === null || groupIds === void 0 ? void 0 : groupIds.length)) {
                return copyPatchSelection(appId, firstPatch, patchIds, groupIds, patchwork, customLogic, !hasMatch);
            }
        };
        _this.patchCopyClear = function () { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, localStorage.removeItem(PATCH_COPY_TYPE.MONO)];
                    case 1:
                        _a.sent();
                        return [4 /*yield*/, localStorage.removeItem(PATCH_COPY_TYPE.POLY)];
                    case 2:
                        _a.sent();
                        return [4 /*yield*/, localStorage.removeItem(PATCH_COPY_TYPE.CONTEXT)];
                    case 3:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        }); };
        _this.handleOnPaste = function () { return __awaiter(_this, void 0, void 0, function () {
            var appId, _a, clonePolyPatch, cloneMonoPatch, patchwork, polyCopyItem, contextCopyItem, monoCopyItem, copyItem, savedPolyPatchCopy_1, connected, savedMonoPatchCopy_1, patchType, connected;
            var _b, _c, _d, _e;
            return __generator(this, function (_f) {
                switch (_f.label) {
                    case 0:
                        appId = this.props.params.appId;
                        _a = this.props, clonePolyPatch = _a.clonePolyPatch, cloneMonoPatch = _a.cloneMonoPatch, patchwork = _a.patchwork;
                        polyCopyItem = localStorage.getItem(PATCH_COPY_TYPE.POLY);
                        contextCopyItem = localStorage.getItem(PATCH_COPY_TYPE.CONTEXT);
                        monoCopyItem = localStorage.getItem(PATCH_COPY_TYPE.MONO);
                        if (!(polyCopyItem || contextCopyItem)) return [3 /*break*/, 4];
                        copyItem = polyCopyItem !== null && polyCopyItem !== void 0 ? polyCopyItem : contextCopyItem;
                        savedPolyPatchCopy_1 = JSON.parse(copyItem);
                        connected = (_c = (_b = patchwork === null || patchwork === void 0 ? void 0 : patchwork.patchwork) === null || _b === void 0 ? void 0 : _b.edges) === null || _c === void 0 ? void 0 : _c.some(function (item) { return (item === null || item === void 0 ? void 0 : item.to_patch) === (savedPolyPatchCopy_1 === null || savedPolyPatchCopy_1 === void 0 ? void 0 : savedPolyPatchCopy_1.patches[0]); });
                        if (!(appId !== (savedPolyPatchCopy_1 === null || savedPolyPatchCopy_1 === void 0 ? void 0 : savedPolyPatchCopy_1.appId) &&
                            !(savedPolyPatchCopy_1 === null || savedPolyPatchCopy_1 === void 0 ? void 0 : savedPolyPatchCopy_1.validCrossAppCopy))) return [3 /*break*/, 1];
                        toast.error("You can't paste these patches outside of the app.");
                        return [3 /*break*/, 3];
                    case 1:
                        savedPolyPatchCopy_1.app = appId;
                        savedPolyPatchCopy_1.copiedPatchworkId = patchwork.patchwork.id;
                        savedPolyPatchCopy_1.x = Math.round(this.state.cursorPosition.x);
                        savedPolyPatchCopy_1.y = Math.round(this.state.cursorPosition.y);
                        savedPolyPatchCopy_1.connected = connected;
                        return [4 /*yield*/, clonePolyPatch(savedPolyPatchCopy_1)];
                    case 2:
                        _f.sent();
                        this.patchCopyClear();
                        _f.label = 3;
                    case 3: return [3 /*break*/, 9];
                    case 4:
                        if (!monoCopyItem) return [3 /*break*/, 9];
                        savedMonoPatchCopy_1 = JSON.parse(monoCopyItem);
                        savedMonoPatchCopy_1.copiedPatchworkId = patchwork.patchwork.id;
                        if (!(['custom_logic', 'view', 'navigation', 'list'].includes(savedMonoPatchCopy_1 === null || savedMonoPatchCopy_1 === void 0 ? void 0 : savedMonoPatchCopy_1.type) &&
                            appId !== (savedMonoPatchCopy_1 === null || savedMonoPatchCopy_1 === void 0 ? void 0 : savedMonoPatchCopy_1.appId))) return [3 /*break*/, 5];
                        patchType = (savedMonoPatchCopy_1 === null || savedMonoPatchCopy_1 === void 0 ? void 0 : savedMonoPatchCopy_1.type) === 'custom_logic'
                            ? 'custom logic'
                            : savedMonoPatchCopy_1 === null || savedMonoPatchCopy_1 === void 0 ? void 0 : savedMonoPatchCopy_1.type;
                        toast.error("You cannot paste ".concat(patchType, " patch outside of the app."));
                        return [3 /*break*/, 9];
                    case 5:
                        if (!((savedMonoPatchCopy_1 === null || savedMonoPatchCopy_1 === void 0 ? void 0 : savedMonoPatchCopy_1.type) === 'custom_logic')) return [3 /*break*/, 7];
                        connected = (_e = (_d = patchwork === null || patchwork === void 0 ? void 0 : patchwork.patchwork) === null || _d === void 0 ? void 0 : _d.edges) === null || _e === void 0 ? void 0 : _e.some(function (item) { return (item === null || item === void 0 ? void 0 : item.to_patch) === (savedMonoPatchCopy_1 === null || savedMonoPatchCopy_1 === void 0 ? void 0 : savedMonoPatchCopy_1.patches[0]); });
                        savedMonoPatchCopy_1.app = appId;
                        savedMonoPatchCopy_1.copiedPatchworkId = patchwork.patchwork.id;
                        savedMonoPatchCopy_1.x = Math.round(this.state.cursorPosition.x);
                        savedMonoPatchCopy_1.y = Math.round(this.state.cursorPosition.y);
                        savedMonoPatchCopy_1.connected = connected;
                        return [4 /*yield*/, clonePolyPatch(savedMonoPatchCopy_1)];
                    case 6:
                        _f.sent();
                        return [3 /*break*/, 8];
                    case 7:
                        cloneMonoPatch(savedMonoPatchCopy_1);
                        _f.label = 8;
                    case 8:
                        this.patchCopyClear();
                        _f.label = 9;
                    case 9: return [2 /*return*/];
                }
            });
        }); };
        _this.showToast = function () {
            toast.error('Failed to copy selection');
        };
        _this.checkPlatforms = function () { return __awaiter(_this, void 0, void 0, function () {
            var _a, fetchSubdomain, checkFirebaseIOSApp, checkFirebaseAndroidApp;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = this.props, fetchSubdomain = _a.fetchSubdomain, checkFirebaseIOSApp = _a.checkFirebaseIOSApp, checkFirebaseAndroidApp = _a.checkFirebaseAndroidApp;
                        return [4 /*yield*/, fetchSubdomain()];
                    case 1:
                        _b.sent();
                        return [4 /*yield*/, checkFirebaseIOSApp()];
                    case 2:
                        _b.sent();
                        return [4 /*yield*/, checkFirebaseAndroidApp()];
                    case 3:
                        _b.sent();
                        this.setState({ platformsFetched: true });
                        return [2 /*return*/];
                }
            });
        }); };
        _this.arraysEqualById = function (arr1, arr2) {
            if (arr1 === void 0) { arr1 = []; }
            if (arr2 === void 0) { arr2 = []; }
            if (arr1 === arr2)
                return true;
            if (arr1.length !== arr2.length)
                return false;
            var ids1 = arr1.map(function (item) { return item.id; }).sort();
            var ids2 = arr2.map(function (item) { return item.id; }).sort();
            return ids1.every(function (id, i) { return id === ids2[i]; });
        };
        _this.confirmation = function (message) {
            if (!window) {
                return true;
            }
            // eslint-disable-next-line no-alert
            return window.confirm(message || 'Are you sure?');
        };
        _this.syncSelectedEdgesWithCustomLogicChanges = function (patches, edges, outputParamSync) { return __awaiter(_this, void 0, void 0, function () {
            var patchMap, _i, patches_1, patch, _a, edges_1, edge;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!outputParamSync)
                            return [2 /*return*/];
                        patchMap = new Map();
                        for (_i = 0, patches_1 = patches; _i < patches_1.length; _i++) {
                            patch = patches_1[_i];
                            if ((patch === null || patch === void 0 ? void 0 : patch.type) === 'logic' &&
                                (patch === null || patch === void 0 ? void 0 : patch.logic) === 'custom_logic' &&
                                (patch === null || patch === void 0 ? void 0 : patch.custom_logic) === outputParamSync.ref) {
                                patchMap.set(patch.id, patch === null || patch === void 0 ? void 0 : patch.name);
                            }
                        }
                        _a = 0, edges_1 = edges;
                        _b.label = 1;
                    case 1:
                        if (!(_a < edges_1.length)) return [3 /*break*/, 4];
                        edge = edges_1[_a];
                        if (!(!!patchMap.get(edge === null || edge === void 0 ? void 0 : edge.from_patch) &&
                            (edge === null || edge === void 0 ? void 0 : edge.from_arg) === (outputParamSync === null || outputParamSync === void 0 ? void 0 : outputParamSync.prevName))) return [3 /*break*/, 3];
                        return [4 /*yield*/, this.onEdgeUpdated(produce(edge, function (tempEdge) {
                                tempEdge.from_arg = outputParamSync === null || outputParamSync === void 0 ? void 0 : outputParamSync.currName;
                                return tempEdge;
                            }))];
                    case 2:
                        _b.sent();
                        _b.label = 3;
                    case 3:
                        _a++;
                        return [3 /*break*/, 1];
                    case 4:
                        this.props.resetOutputParamSync();
                        return [2 /*return*/];
                }
            });
        }); };
        _this.getInputEdgeByPatch = function (patch, input, edges) {
            //* Following code snippet is written with the assumption of having only one input port for each patch
            return edges === null || edges === void 0 ? void 0 : edges.find(function (edge) { return (edge === null || edge === void 0 ? void 0 : edge.to_patch) === (patch === null || patch === void 0 ? void 0 : patch.id) && (edge === null || edge === void 0 ? void 0 : edge.to_arg) === (input === null || input === void 0 ? void 0 : input.name); });
        };
        _this.updateMissingParamsPropInCustomLogicPatchSettings = function (patch, edge, isLogicGroup) {
            var _a, _b, _c, _d, _e, _f;
            if (!patch || (patch === null || patch === void 0 ? void 0 : patch.logic) !== 'custom_logic')
                return;
            //* Assuming that default input port name is in:__view__
            var defaultInput = (_a = patch === null || patch === void 0 ? void 0 : patch.inputs) === null || _a === void 0 ? void 0 : _a.find(function (input) { return (input === null || input === void 0 ? void 0 : input.name) === 'in:__view__'; });
            var inputEdge = {};
            if (edge === null || edge === void 0 ? void 0 : edge.to_patch) {
                inputEdge = edge;
            }
            else if (isLogicGroup) {
                var patchwork = ((_b = _this.props) === null || _b === void 0 ? void 0 : _b.patchwork).patchwork;
                inputEdge = _this.getInputEdgeByPatch(patch, defaultInput, patchwork === null || patchwork === void 0 ? void 0 : patchwork.originalEdges);
            }
            else {
                //* Following code snippet is written with the assumption of having only one input port for each patch
                var patchwork = ((_c = _this.props) === null || _c === void 0 ? void 0 : _c.patchwork).patchwork;
                inputEdge = _this.getInputEdgeByPatch(patch, defaultInput, patchwork === null || patchwork === void 0 ? void 0 : patchwork.edges);
            }
            if (!((_d = defaultInput.value) === null || _d === void 0 ? void 0 : _d.length)) {
                defaultInput.value = [];
            }
            var isMissing = (_f = ((_e = defaultInput === null || defaultInput === void 0 ? void 0 : defaultInput.value) !== null && _e !== void 0 ? _e : [])) === null || _f === void 0 ? void 0 : _f.find(function (arg) { var _a, _b, _c; return (arg === null || arg === void 0 ? void 0 : arg.required) && !((_c = (_b = (_a = inputEdge === null || inputEdge === void 0 ? void 0 : inputEdge.meta) === null || _a === void 0 ? void 0 : _a.params) === null || _b === void 0 ? void 0 : _b[arg === null || arg === void 0 ? void 0 : arg.name]) === null || _c === void 0 ? void 0 : _c.sourceId); });
            // if (patch?.settings?.missing_params !== !!isMissing) {
            //   this.onPatchUpdate({
            //     ...patch,
            //     settings: {
            //       ...patch?.settings,
            //       missing_params: !!isMissing,
            //     },
            //   });
            //   this.onEdgeUpdated(
            //     {
            //       ...inputEdge,
            //       meta: {
            //         ...inputEdge?.meta,
            //         missing_params: !!isMissing,
            //       },
            //     },
            //     { patchId: patch.id, holdParamCheck: true },
            //   );
            // }
        };
        _this.updateCustomLogicPatchesWithRequiredInputs = function (updatedEdge, isLogicGroup) {
            var _a, _b, _c;
            var patchwork = ((_a = _this.props) === null || _a === void 0 ? void 0 : _a.patchwork).patchwork;
            if (updatedEdge) {
                var targetPatch = (_b = patchwork === null || patchwork === void 0 ? void 0 : patchwork.originalPatches) === null || _b === void 0 ? void 0 : _b.find(function (patch) {
                    return (patch === null || patch === void 0 ? void 0 : patch.id) === updatedEdge.to_patch && (patch === null || patch === void 0 ? void 0 : patch.logic) === 'custom_logic';
                });
                _this.updateMissingParamsPropInCustomLogicPatchSettings(targetPatch, updatedEdge);
            }
            else {
                var customLogicPatches = (_c = patchwork === null || patchwork === void 0 ? void 0 : patchwork.patches) === null || _c === void 0 ? void 0 : _c.filter(function (patch) {
                    return (patch === null || patch === void 0 ? void 0 : patch.logic) === 'custom_logic' &&
                        (isLogicGroup || !Object.hasOwn(patch === null || patch === void 0 ? void 0 : patch.settings, 'missing_params'));
                });
                if (customLogicPatches === null || customLogicPatches === void 0 ? void 0 : customLogicPatches.length) {
                    customLogicPatches === null || customLogicPatches === void 0 ? void 0 : customLogicPatches.forEach(function (patch) {
                        _this.updateMissingParamsPropInCustomLogicPatchSettings(patch, null, isLogicGroup);
                    });
                }
            }
        };
        _this.setEntrypoint = function (patch) { return __awaiter(_this, void 0, void 0, function () {
            var _a, patchwork, updatePatchwork, getPatchwork;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = this.props, patchwork = _a.patchwork, updatePatchwork = _a.updatePatchwork, getPatchwork = _a.getPatchwork;
                        return [4 /*yield*/, updatePatchwork(patchwork.patchwork.id, {
                                entrypoint: patch === null || patch === void 0 ? void 0 : patch.id,
                            })];
                    case 1:
                        _b.sent();
                        this.setState({
                            entrypointWarningOpen: false,
                            entryPatch: '',
                        });
                        getPatchwork();
                        return [2 /*return*/];
                }
            });
        }); };
        _this.onSetEntrypoint = function (node) {
            var _a, _b, _c, _d;
            var pushTemplates = _this.props.pushTemplates;
            if (((_b = (_a = node === null || node === void 0 ? void 0 : node[0]) === null || _a === void 0 ? void 0 : _a.patch) === null || _b === void 0 ? void 0 : _b.type) !== 'logic') {
                (pushTemplates === null || pushTemplates === void 0 ? void 0 : pushTemplates.length)
                    ? _this.setState({
                        entrypointWarningOpen: true,
                        entryPatch: (_c = node[0]) === null || _c === void 0 ? void 0 : _c.patch,
                    })
                    : _this.setEntrypoint((_d = node[0]) === null || _d === void 0 ? void 0 : _d.patch);
            }
        };
        _this.onEdgeAdded = function (edge) { return __awaiter(_this, void 0, void 0, function () {
            var _a, patchwork, createEdge, selectGroup, _b, edges, originalEdge, patchId, fromPatch, toPatch, encounteredOnLogicExecute, encounteredViewPatchInput, traverseBackward, traverseForward, groupSelected, existingEdges, _i, existingEdges_1, existingEdge, existingEdges, _loop_1, this_1, _c, existingEdges_2, existingEdge, groupSelected;
            var _this = this;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        _a = this.props, patchwork = _a.patchwork, createEdge = _a.createEdge, selectGroup = _a.selectGroup;
                        _b = ((patchwork === null || patchwork === void 0 ? void 0 : patchwork.patchwork) || {}).edges, edges = _b === void 0 ? [] : _b;
                        originalEdge = cleanEdgeArgName(edge);
                        patchId = getPatchIdFromName(edge.from_arg);
                        if (patchId) {
                            // there is a patch id in the from_arg
                            originalEdge = __assign(__assign({}, originalEdge), { from_patch: patchId });
                        }
                        fromPatch = patchwork.patchwork.patches.find(function (p) { return p.id === originalEdge.from_patch; });
                        toPatch = patchwork.patchwork.patches.find(function (p) { return p.id === originalEdge.to_patch; });
                        traverseBackward = function (edges, loopPatchId, visited) {
                            if (visited === void 0) { visited = new Set(); }
                            // Check if the patchId has already been visited to avoid infinite loops
                            if (visited.has(loopPatchId)) {
                                return null; // Return null if there's a cycle in the graph
                            }
                            // Add the current patchId to the visited set
                            visited.add(loopPatchId);
                            // If the new edge is from OnLogicExecute, change the flag & return
                            if (edge.from_arg === 'out:__onFocus__' ||
                                edge.from_arg === 'out:__onStart__' ||
                                (fromPatch === null || fromPatch === void 0 ? void 0 : fromPatch.logic) === 'async_logic') {
                                encounteredOnLogicExecute = true;
                                return;
                            }
                            var _loop_2 = function (edge_1) {
                                var fromPatchOfLoopPatch = patchwork.patchwork.patches.find(function (p) { return p.id === edge_1.from_patch; });
                                if (edge_1.to_patch === loopPatchId) {
                                    // If a connected edge is from OnLogicExecute, change the flag & break the loop
                                    if (edge_1.from_arg === 'out:__onFocus__' ||
                                        edge_1.from_arg === 'out:__onStart__' ||
                                        (fromPatchOfLoopPatch === null || fromPatchOfLoopPatch === void 0 ? void 0 : fromPatchOfLoopPatch.logic) === 'async_logic') {
                                        encounteredOnLogicExecute = true;
                                        return { value: void 0 };
                                    }
                                    // Recursively call the function to find the connected patch
                                    traverseBackward(edges, edge_1.from_patch, visited);
                                }
                            };
                            // Iterate through each edge
                            for (var _i = 0, edges_2 = edges; _i < edges_2.length; _i++) {
                                var edge_1 = edges_2[_i];
                                var state_1 = _loop_2(edge_1);
                                if (typeof state_1 === "object")
                                    return state_1.value;
                            }
                            // If no connected patch is found, return the current patchId
                            return loopPatchId;
                        };
                        traverseForward = function (edges, loopPatchId, visited) {
                            if (visited === void 0) { visited = new Set(); }
                            // Check if the patchId has already been visited to avoid infinite loops
                            if (visited.has(loopPatchId)) {
                                return null; // Return null if there's a cycle in the graph
                            }
                            // Add the current patchId to the visited set
                            visited.add(loopPatchId);
                            // Check if the new edge's to_patch is a non-logic patch, change the flag & return
                            var originalEdgestoPatch = patchwork.patchwork.allPatches.find(function (p) { return p.id === originalEdge.to_patch; });
                            if (originalEdgestoPatch.type !== 'logic') {
                                encounteredViewPatchInput = true;
                                return;
                            }
                            var _loop_3 = function (edge_2) {
                                // Check if the edge's to_patch matches the given patchId
                                if (edge_2.from_patch === loopPatchId) {
                                    var thePatch = patchwork.patchwork.allPatches.find(function (p) { return p.id === edge_2.to_patch; });
                                    // If a connected patch patch is a non-logic patch change the flag & break the loop
                                    if (thePatch.type !== 'logic') {
                                        encounteredViewPatchInput = true;
                                        return { value: void 0 };
                                    }
                                    // Recursively call the function to find the connected patch
                                    traverseBackward(edges, edge_2.to_patch, visited);
                                }
                            };
                            // Iterate through each edge
                            for (var _i = 0, edges_3 = edges; _i < edges_3.length; _i++) {
                                var edge_2 = edges_3[_i];
                                var state_2 = _loop_3(edge_2);
                                if (typeof state_2 === "object")
                                    return state_2.value;
                            }
                            // If no connected patch is found, return the current patchId
                            return loopPatchId;
                        };
                        traverseBackward(edges, originalEdge.from_patch);
                        traverseForward(edges, originalEdge.to_patch);
                        if (!(encounteredViewPatchInput && encounteredOnLogicExecute)) return [3 /*break*/, 2];
                        toast.error('Non Logic Patches Cannot be connected here');
                        return [4 /*yield*/, this.props.getPatchwork()];
                    case 1:
                        _d.sent();
                        return [2 /*return*/];
                    case 2:
                        if (!(fromPatch && toPatch)) return [3 /*break*/, 11];
                        groupSelected = patchwork.patchwork.group !== null;
                        if (!(groupSelected &&
                            fromPatch.type === 'logic' &&
                            toPatch.type === 'logic')) return [3 /*break*/, 11];
                        if (!(toPatch.id === patchwork.patchwork.entrypoint)) return [3 /*break*/, 7];
                        existingEdges = patchwork.patchwork.originalEdges.filter(function (e) { return e.to_patch === toPatch.id; });
                        _i = 0, existingEdges_1 = existingEdges;
                        _d.label = 3;
                    case 3:
                        if (!(_i < existingEdges_1.length)) return [3 /*break*/, 6];
                        existingEdge = existingEdges_1[_i];
                        // there is an edge, delete it
                        return [4 /*yield*/, this.onEdgeDelete(existingEdge, true)];
                    case 4:
                        // there is an edge, delete it
                        _d.sent();
                        _d.label = 5;
                    case 5:
                        _i++;
                        return [3 /*break*/, 3];
                    case 6: return [3 /*break*/, 11];
                    case 7:
                        existingEdges = patchwork.patchwork.originalEdges.filter(function (e) { return e.from_patch === fromPatch.id; });
                        _loop_1 = function (existingEdge) {
                            var connectingPatch;
                            return __generator(this, function (_e) {
                                switch (_e.label) {
                                    case 0:
                                        connectingPatch = patchwork.patchwork.originalPatches.find(function (p) { return p.id === existingEdge.to_patch; });
                                        if (!((connectingPatch === null || connectingPatch === void 0 ? void 0 : connectingPatch.type) !== 'logic')) return [3 /*break*/, 2];
                                        // there is an edge to a non logic patch, delete it
                                        return [4 /*yield*/, this_1.onEdgeDelete(existingEdge, true)];
                                    case 1:
                                        // there is an edge to a non logic patch, delete it
                                        _e.sent();
                                        _e.label = 2;
                                    case 2: return [2 /*return*/];
                                }
                            });
                        };
                        this_1 = this;
                        _c = 0, existingEdges_2 = existingEdges;
                        _d.label = 8;
                    case 8:
                        if (!(_c < existingEdges_2.length)) return [3 /*break*/, 11];
                        existingEdge = existingEdges_2[_c];
                        return [5 /*yield**/, _loop_1(existingEdge)];
                    case 9:
                        _d.sent();
                        _d.label = 10;
                    case 10:
                        _c++;
                        return [3 /*break*/, 8];
                    case 11:
                        createEdge(patchwork.patchwork.id, originalEdge).then(function () {
                            _this.updateCustomLogicPatchesWithRequiredInputs(originalEdge);
                        });
                        if (fromPatch && toPatch) {
                            groupSelected = patchwork.patchwork.group !== null;
                            if (!groupSelected &&
                                (fromPatch === null || fromPatch === void 0 ? void 0 : fromPatch.logic) !== 'async_logic' &&
                                ((fromPatch.type === 'logic' && toPatch.type === 'logic') ||
                                    (fromPatch.type === 'logic' && toPatch.type === 'logic_group'))) {
                                // check if a new group is forming and trigger a refresh
                                selectGroup(null);
                            }
                            if (groupSelected) {
                                if (toPatch.id === patchwork.patchwork.entrypoint) {
                                    // new entrypoint, change the selected group
                                    selectGroup(fromPatch.id);
                                }
                            }
                            toast.success("".concat(fromPatch.name, " patch connected to ").concat(toPatch.name, " patch"));
                        }
                        return [2 /*return*/];
                }
            });
        }); };
        _this.onEdgeUpdated = function (edge, extraUpdateObject) {
            var _a, _b, _c;
            if (extraUpdateObject === void 0) { extraUpdateObject = { patchId: null, holdParamCheck: false }; }
            var _d = _this.props, patchwork = _d.patchwork, updateEdge = _d.updateEdge;
            var _e = ((_a = patchwork === null || patchwork === void 0 ? void 0 : patchwork.patchwork) !== null && _a !== void 0 ? _a : {}).originalEdges, originalEdges = _e === void 0 ? [] : _e;
            var originalEdge = cleanEdgeArgName(edge);
            var patchId = getPatchIdFromName(edge.from_arg);
            if (patchId && !extraUpdateObject.patchId) {
                // there is a patch id in the from_arg
                originalEdge = __assign(__assign({}, ((_b = originalEdges.find(function (e) { return e.from_patch === patchId; })) !== null && _b !== void 0 ? _b : {})), { meta: edge.meta });
            }
            if (!!extraUpdateObject.patchId) {
                originalEdge = __assign(__assign({}, ((_c = originalEdges.find(function (e) { return e.to_patch === extraUpdateObject.patchId; })) !== null && _c !== void 0 ? _c : {})), { meta: edge.meta });
            }
            updateEdge(patchwork.patchwork.id, originalEdge.id, originalEdge);
            if (!extraUpdateObject.holdParamCheck) {
                _this.updateCustomLogicPatchesWithRequiredInputs(originalEdge);
            }
        };
        _this.onPatchUpdate = function (patch) {
            var _a = _this.props, patchwork = _a.patchwork, updatePatch = _a.updatePatch;
            if (patch.type === 'logic_group') {
                var _b = ((patchwork === null || patchwork === void 0 ? void 0 : patchwork.patchwork) || {}).originalPatches, originalPatches = _b === void 0 ? [] : _b;
                var originalPatch = originalPatches.find(function (p) { return p.id === patch.id; });
                if (originalPatch) {
                    updatePatch(patchwork.patchwork.id, __assign(__assign({}, originalPatch), { x: patch.x, y: patch.y }));
                }
            }
            else {
                updatePatch(patchwork.patchwork.id, patch);
            }
        };
        _this.onLoadDatasetRule = function (patch) {
            var _a;
            var _b = _this.props, getDatasetRule = _b.getDatasetRule, getDatasetPermissionGroup = _b.getDatasetPermissionGroup;
            if (patch.type === 'list' &&
                ((_a = patch.settings.listSource) === null || _a === void 0 ? void 0 : _a.type) === 'dataset') {
                getDatasetRule(patch.settings.listSource.value);
                getDatasetPermissionGroup();
            }
            else if (patch.type === 'logic' && patch.settings.datasetId) {
                getDatasetRule(patch.settings.datasetId);
                getDatasetPermissionGroup();
            }
        };
        _this.onLoadDatasetRuleWithDatasetId = function (datasetId) {
            var _a = _this.props, getDatasetRule = _a.getDatasetRule, getDatasetPermissionGroup = _a.getDatasetPermissionGroup;
            getDatasetRule(datasetId);
            getDatasetPermissionGroup();
        };
        _this.onSaveDatasetRule = function (patch, rule) {
            var createDatasetRule = _this.props.createDatasetRule;
            var appId = _this.props.params.appId;
            if (patch.type === 'list') {
                createDatasetRule(patch.settings.listSource.value, rule, appId);
            }
            else if (patch.type === 'logic') {
                createDatasetRule(patch.settings.datasetId, rule, appId);
            }
        };
        _this.onPatchDelete = function (entities) { return __awaiter(_this, void 0, void 0, function () {
            var _a, patchwork, deletePatches, selectGroup, getPatchwork, _b, selectedPatches, shouldExitGroup;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        _a = this.props, patchwork = _a.patchwork, deletePatches = _a.deletePatches, selectGroup = _a.selectGroup, getPatchwork = _a.getPatchwork;
                        if (!(entities === null || entities === void 0 ? void 0 : entities.length)) return [3 /*break*/, 3];
                        _b = resolvePatchesToDelete(entities, patchwork.patchwork), selectedPatches = _b.selectedPatches, shouldExitGroup = _b.shouldExitGroup;
                        if (shouldExitGroup) {
                            selectGroup(null);
                        }
                        if (!selectedPatches.length) return [3 /*break*/, 3];
                        return [4 /*yield*/, deletePatches(patchwork.patchwork.id, selectedPatches)];
                    case 1:
                        _c.sent();
                        this.setState({
                            selectedEntity: null,
                            propertiesBarView: 'empty',
                        });
                        return [4 /*yield*/, getPatchwork()];
                    case 2:
                        _c.sent();
                        _c.label = 3;
                    case 3: return [2 /*return*/];
                }
            });
        }); };
        _this.shouldRemoveLink = function (link) {
            if (link === void 0) { link = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var sourcePort, targetPort, _a, patchwork, deleteEdge, getPatchwork, _b, edges, edge_3, updatingPatch, items, contextItems;
                var _this = this;
                var _c, _d, _e, _f, _g, _h;
                return __generator(this, function (_j) {
                    switch (_j.label) {
                        case 0:
                            sourcePort = link.sourcePort, targetPort = link.targetPort;
                            // When target port is null, structure builder automatically delete the link
                            if (!targetPort)
                                return [2 /*return*/];
                            if (!this.confirmation('Are you sure you want to delete this link?')) return [3 /*break*/, 2];
                            if (!(sourcePort &&
                                sourcePort.patch &&
                                sourcePort.patch.id &&
                                targetPort &&
                                targetPort.patch &&
                                targetPort.patch.id)) return [3 /*break*/, 2];
                            _a = this.props, patchwork = _a.patchwork, deleteEdge = _a.deleteEdge, getPatchwork = _a.getPatchwork;
                            _b = patchwork.patchwork.edges, edges = _b === void 0 ? [] : _b;
                            edge_3 = edges.find(function (e) {
                                return e.from_patch === sourcePort.patch.id &&
                                    e.to_patch === targetPort.patch.id &&
                                    e.from_arg === sourcePort.name;
                            });
                            if (!edge_3) return [3 /*break*/, 2];
                            this.setState({
                                toDeleteEdges: [edge_3],
                            });
                            deleteEdge(patchwork.patchwork.id, edge_3.id, function () {
                                var _a;
                                if (((_a = targetPort === null || targetPort === void 0 ? void 0 : targetPort.patch) === null || _a === void 0 ? void 0 : _a.logic) === 'custom_logic') {
                                    _this.updateMissingParamsPropInCustomLogicPatchSettings(targetPort === null || targetPort === void 0 ? void 0 : targetPort.patch, __assign(__assign({}, edge_3), { meta: __assign(__assign({}, edge_3.meta), { params: {} }) }));
                                }
                            });
                            this.onDeselect();
                            updatingPatch = (_d = (_c = patchwork === null || patchwork === void 0 ? void 0 : patchwork.patchwork) === null || _c === void 0 ? void 0 : _c.patches) === null || _d === void 0 ? void 0 : _d.find(function (item) { return item.id === edge_3.from_patch; });
                            if (updatingPatch.type === 'navigation' &&
                                (edge_3.from_arg === 'out:__contextItem__' ||
                                    edge_3.from_arg === 'out:__menuItem__')) {
                                items = ((_f = (_e = updatingPatch === null || updatingPatch === void 0 ? void 0 : updatingPatch.settings) === null || _e === void 0 ? void 0 : _e.items) === null || _f === void 0 ? void 0 : _f.filter(function (val) { return val !== edge_3.id; })) ||
                                    [];
                                contextItems = ((_h = (_g = updatingPatch === null || updatingPatch === void 0 ? void 0 : updatingPatch.settings) === null || _g === void 0 ? void 0 : _g.contextItems) === null || _h === void 0 ? void 0 : _h.filter(function (val) { return val !== edge_3.id; })) || [];
                                this.onPatchUpdate(__assign(__assign({}, updatingPatch), { settings: __assign(__assign({}, updatingPatch.settings), { items: items, contextItems: contextItems }) }));
                            }
                            this.onEdgeSelected(null);
                            return [4 /*yield*/, getPatchwork()];
                        case 1:
                            _j.sent();
                            _j.label = 2;
                        case 2: return [2 /*return*/];
                    }
                });
            });
        };
        _this.onEdgeDelete = function (edge, updateSelection) {
            if (updateSelection === void 0) { updateSelection = true; }
            return __awaiter(_this, void 0, void 0, function () {
                var _a, patchwork, deleteEdge;
                var _this = this;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            if (!(edge && edge.id)) return [3 /*break*/, 2];
                            _a = this.props, patchwork = _a.patchwork, deleteEdge = _a.deleteEdge;
                            return [4 /*yield*/, deleteEdge(patchwork.patchwork.id, edge.id, function () {
                                    return _this.updateCustomLogicPatchesWithRequiredInputs(__assign(__assign({}, edge), { meta: __assign(__assign({}, edge.meta), { params: {} }) }));
                                })];
                        case 1:
                            _b.sent();
                            if (updateSelection) {
                                this.onEdgeSelected(null);
                                this.onDeselect();
                            }
                            _b.label = 2;
                        case 2: return [2 /*return*/];
                    }
                });
            });
        };
        _this.onEdgeDeleteAndRefresh = function (edge, updateSelection) {
            if (updateSelection === void 0) { updateSelection = true; }
            return __awaiter(_this, void 0, void 0, function () {
                var _a;
                var _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0:
                            _d.trys.push([0, 3, , 4]);
                            return [4 /*yield*/, this.onEdgeDelete(edge, updateSelection)];
                        case 1:
                            _d.sent();
                            return [4 /*yield*/, ((_c = (_b = this.props) === null || _b === void 0 ? void 0 : _b.getPatchwork) === null || _c === void 0 ? void 0 : _c.call(_b))];
                        case 2:
                            _d.sent();
                            return [3 /*break*/, 4];
                        case 3:
                            _a = _d.sent();
                            return [3 /*break*/, 4];
                        case 4: return [2 /*return*/];
                    }
                });
            });
        };
        _this.onPatchSelected = function (patch) {
            var _a;
            if ((_a = patch === null || patch === void 0 ? void 0 : patch.settings) === null || _a === void 0 ? void 0 : _a.toSync)
                return;
            _this.setState({
                selectedEntity: buildPatchSelection(patch),
                propertiesBarView: 'patch',
            });
        };
        _this.onEdgeSelected = function (edge) {
            var update = resolveEdgeSelection(edge, _this.state.selectedEntity);
            if (!update)
                return;
            _this.setState(update);
        };
        _this.onDeselect = function () {
            _this.setState({
                selectedEntity: null,
                propertiesBarView: 'empty',
            });
        };
        _this.onDirectOnce = function (value) {
            _this.setState({
                directOnce: value,
            });
        };
        _this.onRemoveFocus = function () {
            _this.setState({
                directedPatch: {
                    label: '',
                    value: '',
                },
            });
        };
        _this.onCursorPosition = function (x, y) {
            _this.setState({
                cursorPosition: {
                    x: x,
                    y: y,
                },
            });
        };
        _this.onSearchResultClick = function (result) {
            var selectedPatch = _this.props.patchwork.patchwork.allPatches.find(function (patch) { return patch.id === result.value; });
            _this.onPatchSelected(selectedPatch);
        };
        _this.onPatchSearchSelect = function (id) {
            var selectedPatch = _this.props.patchwork.patchwork.allPatches.find(function (patch) { return patch.id === id; });
            _this.onPatchSelected(selectedPatch);
        };
        _this.onPatchAddNewEvent = function (_a) {
            var name = _a.name, viewId = _a.viewId;
            return __awaiter(_this, void 0, void 0, function () {
                var _b;
                return __generator(this, function (_c) {
                    switch (_c.label) {
                        case 0:
                            _c.trys.push([0, 4, , 5]);
                            return [4 /*yield*/, this.props.createViewEvent(name, viewId)];
                        case 1:
                            _c.sent();
                            return [4 /*yield*/, this.props.getViews()];
                        case 2:
                            _c.sent();
                            return [4 /*yield*/, this.props.getPatchwork()];
                        case 3:
                            _c.sent();
                            return [3 /*break*/, 5];
                        case 4:
                            _b = _c.sent();
                            toast.error("Failed to add new ".concat(name, " event"));
                            return [3 /*break*/, 5];
                        case 5: return [2 /*return*/];
                    }
                });
            });
        };
        _this.buildProperties = function (propertiesList, port, patch, sourcePatch) {
            var _a, _b, _c, _d, _e, _f, _g, _h;
            var _j = _this.props.patchwork, _k = _j.datasets, datasets = _k === void 0 ? [] : _k, _l = _j.integrations, integrations = _l === void 0 ? [] : _l, _m = _j.views, views = _m === void 0 ? [] : _m, _o = _j.patchwork, _p = _o.allPatches, patches = _p === void 0 ? [] : _p, edges = _o.edges;
            var _q = _this.props, states = _q.states.states, storage = _q.globalStorage.storage, variables = _q.variables.variables, environments = _q.environments.environments, datasetRules = _q.datasetRules;
            var ruleVarTypesToPropertyTypes = {
                text: 'string',
                number: 'number',
                boolean: 'boolean',
                timestamp: 'time',
            };
            if (patch.type === 'view') {
                var ports = void 0;
                if (patch.inputs.findIndex(function (p) { return (p && p.name) === (port && port.name); }) > -1) {
                    ports = patch.inputs;
                }
                else {
                    ports = patch.outputs;
                }
                propertiesList.push.apply(propertiesList, _this.getVanityPorts(ports).map(function (p) { return ({
                    type: p.type,
                    id: p.name,
                    dataField: cleanPortName(p.name),
                }); }));
            }
            else if (patch.type === 'list' && patch.list === 'from_view') {
                if (sourcePatch) {
                    propertiesList.push({
                        type: 'list',
                        id: 'items',
                        dataField: 'items',
                    });
                    var selectedRule = datasetRules === null || datasetRules === void 0 ? void 0 : datasetRules.find(function (rule) { var _a; return rule.id === ((_a = patch === null || patch === void 0 ? void 0 : patch.settings) === null || _a === void 0 ? void 0 : _a.ruleId); });
                    if (selectedRule && selectedRule.actions.includes('multi-read')) {
                        (_a = selectedRule === null || selectedRule === void 0 ? void 0 : selectedRule.variables) === null || _a === void 0 ? void 0 : _a.forEach(function (variable) {
                            propertiesList.push({
                                type: ruleVarTypesToPropertyTypes[variable.type],
                                id: variable.name,
                                dataField: variable.name,
                            });
                        });
                        (_b = selectedRule === null || selectedRule === void 0 ? void 0 : selectedRule.environments) === null || _b === void 0 ? void 0 : _b.forEach(function (environments) {
                            propertiesList.push({
                                type: ruleVarTypesToPropertyTypes[environments.type],
                                id: environments.name,
                                dataField: environments.name,
                            });
                        });
                    }
                }
                if (!sourcePatch) {
                    propertiesList.push({
                        type: 'json',
                        id: 'item',
                        dataField: 'item',
                    });
                    if (((_d = (_c = patch === null || patch === void 0 ? void 0 : patch.settings) === null || _c === void 0 ? void 0 : _c.listSource) === null || _d === void 0 ? void 0 : _d.type) === 'dataset') {
                        var dataset = datasets.find(function (m) { var _a, _b; return m.id === ((_b = (_a = patch === null || patch === void 0 ? void 0 : patch.settings) === null || _a === void 0 ? void 0 : _a.listSource) === null || _b === void 0 ? void 0 : _b.value); });
                        if (dataset) {
                            propertiesList.push.apply(propertiesList, dataset.fields.map(function (field) { return ({
                                type: field.type,
                                id: field.name,
                                dataField: field.name,
                            }); }));
                        }
                    }
                    else {
                        var selectedView = views.find(function (item) { return item.id === patch.view; });
                        if (selectedView) {
                            propertiesList.push.apply(propertiesList, selectedView.inputs.map(function (field) { return ({
                                type: field.type,
                                id: field.name,
                                dataField: field.name,
                            }); }));
                        }
                    }
                }
            }
            else if (patch.type === 'dataset' ||
                (patch.type === 'list' && patch.list === 'from_dataset')) {
                var dataset = datasets.find(function (m) { return m.id === patch.dataset; });
                if (dataset) {
                    if (!sourcePatch) {
                        propertiesList.push({
                            type: 'json',
                            id: 'item',
                            dataField: 'item',
                        });
                        propertiesList.push.apply(propertiesList, dataset.fields.map(function (field) { return ({
                            type: field.type,
                            id: field.name,
                            dataField: field.name,
                        }); }));
                    }
                }
            }
            else if (patch.type === 'logic' || 'logic_group') {
                if (patch.logic === 'integration') {
                    var integration = integrations.find(function (m) { return m.id === patch.settings.integrationId; });
                    if (integration) {
                        var method = integration.methods.find(function (m) { return m.id === patch.settings.methodId; });
                        if (method) {
                            if (!sourcePatch) {
                                propertiesList.push.apply(propertiesList, method.outputs.map(function (input) { return ({
                                    type: input.type,
                                    id: input.name,
                                    dataField: input.name,
                                }); }));
                            }
                            else {
                                propertiesList.push.apply(propertiesList, method.inputs.map(function (output) { return ({
                                    type: output.type,
                                    id: output.name,
                                    dataField: output.name,
                                }); }));
                            }
                        }
                    }
                }
                else if (patch.logic === 'custom_logic') {
                    var logicProperties_1 = [];
                    if (sourcePatch) {
                        logicProperties_1 = (_e = patch === null || patch === void 0 ? void 0 : patch.inputs) === null || _e === void 0 ? void 0 : _e.reduce(function (acc, curr) {
                            if (Array.isArray(curr.value)) {
                                acc = __spreadArray(__spreadArray([], acc, true), curr.value, true);
                            }
                            return acc;
                        }, []);
                    }
                    else {
                        var selectedEdge_1 = edges.find(function (e) { var _a; return e.id === ((_a = _this.state.selectedEntity) === null || _a === void 0 ? void 0 : _a.id); });
                        (_f = patch.outputs) === null || _f === void 0 ? void 0 : _f.forEach(function (output) {
                            var _a, _b, _c, _d, _e;
                            if (((_a = output.name) === null || _a === void 0 ? void 0 : _a.toLowerCase()) ===
                                ((_b = selectedEdge_1.from_arg) === null || _b === void 0 ? void 0 : _b.toLowerCase()) ||
                                (((_d = (_c = selectedEdge_1.from_arg) === null || _c === void 0 ? void 0 : _c.toLowerCase()) === null || _d === void 0 ? void 0 : _d.includes((_e = output.name) === null || _e === void 0 ? void 0 : _e.toLowerCase())) &&
                                    Array.isArray(output.value))) {
                                logicProperties_1.push.apply(logicProperties_1, output.value);
                            }
                        });
                    }
                    if (logicProperties_1 === null || logicProperties_1 === void 0 ? void 0 : logicProperties_1.length) {
                        propertiesList.push.apply(propertiesList, logicProperties_1 === null || logicProperties_1 === void 0 ? void 0 : logicProperties_1.map(function (logicProp) { return ({
                            type: logicProp.type,
                            id: logicProp.name,
                            dataField: logicProp.name,
                        }); }));
                    }
                }
                else {
                    var logicProperties = (_h = (_g = getLogicProperties({
                        patches: patches,
                        variables: variables,
                        environments: environments,
                        states: states,
                        storage: storage,
                        datasets: datasets,
                        datasetRules: datasetRules,
                        patch: patch,
                    })) === null || _g === void 0 ? void 0 : _g["".concat(patch.logic, "_props")]) !== null && _h !== void 0 ? _h : [];
                    if (patch.logic === 'push_send') {
                        logicProperties = logicProperties === null || logicProperties === void 0 ? void 0 : logicProperties.filter(function (item) {
                            if (!['patchId', 'datasetId', 'datasetItemId'].includes(item === null || item === void 0 ? void 0 : item.id)) {
                                return item;
                            }
                        });
                    }
                    propertiesList.push.apply(propertiesList, logicProperties === null || logicProperties === void 0 ? void 0 : logicProperties.filter(function (logicProp) {
                        return !sourcePatch ? logicProp === null || logicProp === void 0 ? void 0 : logicProp.isOutput : logicProp === null || logicProp === void 0 ? void 0 : logicProp.isInput;
                    }));
                }
            }
        };
        _this.renderPatchProperties = function () {
            var _a;
            var _b = _this.props.patchwork, patchwork = _b.patchwork, views = _b.views, datasets = _b.datasets, groups = _b.groups, files = _b.files, filesMeta = _b.filesMeta, icons = _b.icons, datasetRows = _b.datasetRows, dataset_rows_loading = _b.dataset_rows_loading, viewState = _b.viewState, location = _b.location, integrations = _b.integrations;
            var _c = _this.props, setLoadingState = _c.setLoadingState, states = _c.states.states, storage = _c.globalStorage.storage, variables = _c.variables.variables, environments = _c.environments.environments, datasetRules = _c.datasetRules, datasetRulesLoading = _c.datasetRulesLoading, datasetNewRuleId = _c.datasetNewRuleId, datasetRuleGroups = _c.datasetRuleGroups, platforms = _c.platforms, goToPlatformPage = _c.goToPlatformPage, goToViewPage = _c.goToViewPage, selectGroup = _c.selectGroup, rulesDatasetId = _c.rulesDatasetId, getDatasetRows = _c.getDatasetRows, 
            // selectDatasetRow,
            selectedApp = _c.selectedApp, currentStyle = _c.currentStyle, stylesLoading = _c.stylesLoading, getPatchwork = _c.getPatchwork;
            var selectedEntity = _this.state.selectedEntity;
            if (!patchwork || !selectedEntity) {
                return null;
            }
            if (selectedEntity.type === 'logic_group') {
                return null;
            }
            var selectedPatch = patchwork.patches.find(function (patch) { return patch.id === selectedEntity.id; });
            if (!selectedPatch) {
                return null;
            }
            var entityName;
            switch (selectedPatch.type) {
                case 'view': {
                    var view = views.find(function (v) { return v.id === selectedPatch.view; });
                    if (view) {
                        entityName = view.name;
                    }
                    break;
                }
                case 'dataset': {
                    var dataset = datasets.find(function (d) { return d.id === selectedPatch.dataset; });
                    if (dataset) {
                        entityName = dataset.name;
                    }
                    break;
                }
                default:
                    entityName = '';
            }
            var inputEdges = patchwork.edges.filter(function (edge) { return edge.to_patch === selectedPatch.id; });
            var outputEdges = patchwork.edges.filter(function (edge) { return edge.from_patch === selectedPatch.id; });
            var specificLogicStates = logicStates && logicStates["".concat(selectedPatch.logic, "_state")];
            return (_jsx(PatchProperties, { patchwork: patchwork, patch: selectedPatch, entityName: entityName, inputs: inputEdges, outputs: outputEdges, updatePatch: _this.onPatchUpdate, setLoadingDataSetRule: _this.onLoadDatasetRule, createDatasetRule: _this.onSaveDatasetRule, datasetNewRuleId: datasetNewRuleId, deleteEdge: _this.onEdgeDeleteAndRefresh, setEntrypoint: _this.onSetEntrypoint, groups: groups, files: files, filesMeta: filesMeta, icons: icons, location: location, datasetRows: datasetRows, datasets: datasets, datasetRules: datasetRules, datasetRulesLoading: datasetRulesLoading, datasetRuleGroups: datasetRuleGroups, datasetRowsLoading: dataset_rows_loading || viewState === 'loading', setLoadingState: setLoadingState, integrations: integrations, views: views, onEdgeUpdated: _this.onEdgeUpdated, states: states, logicStates: specificLogicStates, globalStorage: storage, variables: variables, environments: environments, platforms: platforms, goToPlatformPage: goToPlatformPage, goToViewPage: goToViewPage, selectGroup: selectGroup, rulesDatasetId: rulesDatasetId, getDatasetRows: getDatasetRows, 
                // selectDatasetRow={selectDatasetRow}
                styleId: (_a = selectedApp === null || selectedApp === void 0 ? void 0 : selectedApp.app) === null || _a === void 0 ? void 0 : _a.style, stylesLoading: stylesLoading, styles: currentStyle, selectedApp: selectedApp, reloadPatchwork: getPatchwork, onLoadDatasetRuleWithDatasetId: _this.onLoadDatasetRuleWithDatasetId }, selectedPatch === null || selectedPatch === void 0 ? void 0 : selectedPatch.id));
        };
        _this.renderEdgePropertiesMapper = function () {
            var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1, _2, _3, _4, _5, _6, _7, _8, _9, _10;
            var groups = _this.props.patchwork.groups;
            var selectedEntity = _this.state.selectedEntity;
            var selectedEdge = selectedEntity &&
                selectedEntity.type === 'edge' &&
                ((_d = (_c = (_b = (_a = _this.props) === null || _a === void 0 ? void 0 : _a.patchwork) === null || _b === void 0 ? void 0 : _b.patchwork) === null || _c === void 0 ? void 0 : _c.edges) === null || _d === void 0 ? void 0 : _d.find(function (e) { return e.id === selectedEntity.id; }));
            if (!selectedEdge) {
                return null;
            }
            var sourcePatch = (_g = (_f = (_e = _this.props.patchwork) === null || _e === void 0 ? void 0 : _e.patchwork) === null || _f === void 0 ? void 0 : _f.patches) === null || _g === void 0 ? void 0 : _g.find(function (m) { return m.id === selectedEdge.from_patch; });
            var sourcePort = (_h = sourcePatch === null || sourcePatch === void 0 ? void 0 : sourcePatch.outputs) === null || _h === void 0 ? void 0 : _h.find(function (m) {
                return m.name === selectedEdge.from_arg ||
                    m.name === cleanPortName(selectedEdge.from_arg);
            });
            var sourcePatchId = getPatchIdFromName(selectedEdge.from_arg);
            if (sourcePatchId) {
                sourcePatch = (_l = (_k = (_j = _this.props.patchwork) === null || _j === void 0 ? void 0 : _j.patchwork) === null || _k === void 0 ? void 0 : _k.originalPatches) === null || _l === void 0 ? void 0 : _l.find(function (m) { return m.id === sourcePatchId; });
                sourcePort = (_m = sourcePatch === null || sourcePatch === void 0 ? void 0 : sourcePatch.outputs) === null || _m === void 0 ? void 0 : _m.find(function (m) { return m.name === cleanArgName(selectedEdge.from_arg); });
            }
            if (!sourcePort) {
                return null;
            }
            var targetPatch = (_q = (_p = (_o = _this.props.patchwork) === null || _o === void 0 ? void 0 : _o.patchwork) === null || _p === void 0 ? void 0 : _p.patches) === null || _q === void 0 ? void 0 : _q.find(function (m) { return m.id === selectedEdge.to_patch; });
            var targetPort = (_r = targetPatch === null || targetPatch === void 0 ? void 0 : targetPatch.inputs) === null || _r === void 0 ? void 0 : _r.find(function (m) {
                return m.name === selectedEdge.to_arg ||
                    m.name === cleanPortName(selectedEdge.to_arg);
            });
            if ((targetPatch === null || targetPatch === void 0 ? void 0 : targetPatch.type) === 'logic_group') {
                // if it's a logic group patch we need to find the original patch
                targetPatch = (_u = (_t = (_s = _this.props.patchwork) === null || _s === void 0 ? void 0 : _s.patchwork) === null || _t === void 0 ? void 0 : _t.originalPatches) === null || _u === void 0 ? void 0 : _u.find(function (m) { return m.id === (targetPatch === null || targetPatch === void 0 ? void 0 : targetPatch.in_patch); });
                targetPort = (_v = targetPatch === null || targetPatch === void 0 ? void 0 : targetPatch.inputs) === null || _v === void 0 ? void 0 : _v.find(function (m) { return m.name === selectedEdge.to_arg; });
            }
            if (!targetPort) {
                return null;
            }
            var sourceProperties = [];
            var targetProperties = [];
            // append to source properties from source port and source patch
            _this.buildProperties(sourceProperties, sourcePort, sourcePatch);
            // add state variables to source properties
            // const { states } = this.props?.states || [];
            var variables = (((_w = _this.props) === null || _w === void 0 ? void 0 : _w.variables) || []).variables;
            variables === null || variables === void 0 ? void 0 : variables.forEach(function (_a) {
                var key = _a.key, type = _a.type;
                var id = "var:".concat(key);
                sourceProperties.push({
                    type: type,
                    id: id,
                    dataField: id,
                });
            });
            if ((sourcePatch === null || sourcePatch === void 0 ? void 0 : sourcePatch.logic) === 'get_env') {
                var environments = (((_x = _this.props) === null || _x === void 0 ? void 0 : _x.environments) || []).environments;
                environments === null || environments === void 0 ? void 0 : environments.forEach(function (_a) {
                    var key = _a.key, type = _a.type;
                    var id = "env:".concat(key);
                    sourceProperties.push({
                        type: type,
                        id: id,
                        dataField: id,
                    });
                });
            }
            if ((targetPatch === null || targetPatch === void 0 ? void 0 : targetPatch.type) === 'list' &&
                (targetPatch === null || targetPatch === void 0 ? void 0 : targetPatch.list) === 'from_view' &&
                ((_z = (_y = targetPatch === null || targetPatch === void 0 ? void 0 : targetPatch.settings) === null || _y === void 0 ? void 0 : _y.listSource) === null || _z === void 0 ? void 0 : _z.type) === 'dataset' &&
                ((_1 = (_0 = targetPatch === null || targetPatch === void 0 ? void 0 : targetPatch.settings) === null || _0 === void 0 ? void 0 : _0.listSource) === null || _1 === void 0 ? void 0 : _1.value)) {
                if (sourcePatch &&
                    ((_3 = (_2 = targetPatch === null || targetPatch === void 0 ? void 0 : targetPatch.settings) === null || _2 === void 0 ? void 0 : _2.listSource) === null || _3 === void 0 ? void 0 : _3.value) &&
                    _this.props.rulesDatasetId !== ((_5 = (_4 = targetPatch === null || targetPatch === void 0 ? void 0 : targetPatch.settings) === null || _4 === void 0 ? void 0 : _4.listSource) === null || _5 === void 0 ? void 0 : _5.value)) {
                    _this.props.getDatasetRule((_7 = (_6 = targetPatch === null || targetPatch === void 0 ? void 0 : targetPatch.settings) === null || _6 === void 0 ? void 0 : _6.listSource) === null || _7 === void 0 ? void 0 : _7.value);
                }
            }
            else if ((targetPatch === null || targetPatch === void 0 ? void 0 : targetPatch.type) === 'logic' &&
                ((targetPatch === null || targetPatch === void 0 ? void 0 : targetPatch.logic) === 'add_to_dataset' ||
                    (targetPatch === null || targetPatch === void 0 ? void 0 : targetPatch.logic) === 'remove_from_dataset' ||
                    (targetPatch === null || targetPatch === void 0 ? void 0 : targetPatch.logic) === 'update_dataset' ||
                    (targetPatch === null || targetPatch === void 0 ? void 0 : targetPatch.logic) === 'fetch_dataset_item' ||
                    (targetPatch === null || targetPatch === void 0 ? void 0 : targetPatch.logic) === 'fetch_dataset')) {
                if (sourcePatch &&
                    ((_8 = targetPatch === null || targetPatch === void 0 ? void 0 : targetPatch.settings) === null || _8 === void 0 ? void 0 : _8.datasetId) &&
                    _this.props.rulesDatasetId !== ((_9 = targetPatch === null || targetPatch === void 0 ? void 0 : targetPatch.settings) === null || _9 === void 0 ? void 0 : _9.datasetId)) {
                    _this.props.getDatasetRule((_10 = targetPatch === null || targetPatch === void 0 ? void 0 : targetPatch.settings) === null || _10 === void 0 ? void 0 : _10.datasetId);
                }
            }
            // append to target properties from target port and target patch
            _this.buildProperties(targetProperties, targetPort, targetPatch, sourcePatch);
            return (_jsx(PropertiesMapper, { edgeMeta: selectedEdge.meta, sourcePatch: sourcePatch, targetPatch: targetPatch, sourceProperties: sourceProperties, targetProperties: targetProperties, selectedEdge: selectedEdge, groups: groups, onTargetUpdated: function (target) {
                    _this.onEdgeUpdated(produce(selectedEdge, function (edge) {
                        edge.meta.transition.target = target;
                        return edge;
                    }));
                }, onEdgeUpdated: _this.onEdgeUpdated, receiverApps: _this.props.receiverApps }));
        };
        _this.createPatch = function (patch) { return __awaiter(_this, void 0, void 0, function () {
            var _a, cursorPosition, newPatch;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = this.state.cursorPosition, cursorPosition = _a === void 0 ? { x: 0, y: 0 } : _a;
                        newPatch = __assign({}, patch);
                        if (!(newPatch === null || newPatch === void 0 ? void 0 : newPatch.x) || !(newPatch === null || newPatch === void 0 ? void 0 : newPatch.y)) {
                            if (!(newPatch === null || newPatch === void 0 ? void 0 : newPatch.x))
                                newPatch.x = Math.round(cursorPosition.x) + 100;
                            if (!(newPatch === null || newPatch === void 0 ? void 0 : newPatch.y))
                                newPatch.y = Math.round(cursorPosition.y) + 100;
                        }
                        return [4 /*yield*/, this.props.createPatch(this.props.patchwork.patchwork.id, newPatch)];
                    case 1:
                        _b.sent();
                        toast.success("".concat(newPatch.name, " add to the patchwork"));
                        this.setState({
                            selectedEntity: null,
                        });
                        return [2 /*return*/];
                }
            });
        }); };
        _this.onCreatePatch = function (patch, edge) { return __awaiter(_this, void 0, void 0, function () {
            var createdPatch;
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, this.createPatch(patch)];
                    case 1:
                        _b.sent();
                        createdPatch = (_a = this.props) === null || _a === void 0 ? void 0 : _a.tempNewPatch;
                        if (!createdPatch) return [3 /*break*/, 6];
                        if (!((edge === null || edge === void 0 ? void 0 : edge.from_patch) && (edge === null || edge === void 0 ? void 0 : edge.from_arg))) return [3 /*break*/, 3];
                        return [4 /*yield*/, this.onEdgeAdded(__assign(__assign({}, edge), { to_patch: createdPatch.id, to_arg: 'in:__view__' }))];
                    case 2:
                        _b.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        /**
                         * When adding a custom logic patch, this code snippet checks whether missing_params prop is available
                         * If not, it runs through the missing param checker and update the settings where necessary
                         * This is only when there is not an edge. If there's an edge, same method is invoked by onEdgeAdded method
                         */
                        this.updateMissingParamsPropInCustomLogicPatchSettings(createdPatch);
                        _b.label = 4;
                    case 4:
                        if (!(((createdPatch === null || createdPatch === void 0 ? void 0 : createdPatch.logic) === 'push_send' ||
                            (createdPatch === null || createdPatch === void 0 ? void 0 : createdPatch.logic) === 'deep_linked_push_send') &&
                            !this.state.platformsFetched)) return [3 /*break*/, 6];
                        return [4 /*yield*/, this.checkPlatforms()];
                    case 5:
                        _b.sent();
                        _b.label = 6;
                    case 6: return [2 /*return*/];
                }
            });
        }); };
        _this.onCreateNewView = function (view, edge) { return __awaiter(_this, void 0, void 0, function () {
            var position, newView, _a;
            var _b, _c, _d, _e;
            return __generator(this, function (_f) {
                switch (_f.label) {
                    case 0:
                        position = {};
                        if (view === null || view === void 0 ? void 0 : view.x) {
                            position.x = view.x;
                            delete view.x;
                        }
                        if (view === null || view === void 0 ? void 0 : view.y) {
                            position.y = view.y;
                            delete view.y;
                        }
                        _f.label = 1;
                    case 1:
                        _f.trys.push([1, 10, , 11]);
                        return [4 /*yield*/, this.props.createView(view)];
                    case 2:
                        _f.sent();
                        if (!((_b = this.props) === null || _b === void 0 ? void 0 : _b.createdView)) return [3 /*break*/, 9];
                        return [4 /*yield*/, this.props.getViews()];
                    case 3:
                        _f.sent();
                        newView = this.props.createdView;
                        if (!(newView.type === 'view')) return [3 /*break*/, 5];
                        return [4 /*yield*/, this.createPatch(__assign({ name: newView.name, type: newView.type, view: newView.id, view_name: newView.name, settings: __assign(__assign({}, newView.settings), { toSync: true }) }, position))];
                    case 4:
                        _f.sent();
                        _f.label = 5;
                    case 5:
                        if (!(newView.type === 'list')) return [3 /*break*/, 7];
                        return [4 /*yield*/, this.createPatch(__assign({ name: newView.name, type: newView.type, list: 'from_view', view: newView.id, view_name: newView.name, settings: {
                                    layout: 'list',
                                    loadable: 'loading',
                                    padding: {
                                        paddingTop: 0,
                                        paddingLeft: 0,
                                        paddingRight: 0,
                                        paddingBottom: 0,
                                    },
                                    toSync: true,
                                } }, position))];
                    case 6:
                        _f.sent();
                        _f.label = 7;
                    case 7:
                        if (!(((_c = this.props) === null || _c === void 0 ? void 0 : _c.tempNewPatch) && (edge === null || edge === void 0 ? void 0 : edge.from_patch) && (edge === null || edge === void 0 ? void 0 : edge.from_arg))) return [3 /*break*/, 9];
                        return [4 /*yield*/, this.onEdgeAdded(__assign(__assign({}, edge), { to_patch: this.props.tempNewPatch.id, to_arg: 'in:__view__' }))];
                    case 8:
                        _f.sent();
                        _f.label = 9;
                    case 9: return [3 /*break*/, 11];
                    case 10:
                        _a = _f.sent();
                        toast.error("Failed to create new ".concat((_e = (_d = this.props.createdView) === null || _d === void 0 ? void 0 : _d.type) !== null && _e !== void 0 ? _e : 'view'));
                        return [3 /*break*/, 11];
                    case 11: return [2 /*return*/];
                }
            });
        }); };
        _this.onChangeViewName = function (viewName, viewId) { return __awaiter(_this, void 0, void 0, function () {
            var _a;
            var _b, _c, _d, _e;
            return __generator(this, function (_f) {
                switch (_f.label) {
                    case 0:
                        _f.trys.push([0, 3, 4, 5]);
                        if (!(viewId && viewName)) return [3 /*break*/, 2];
                        return [4 /*yield*/, ((_c = (_b = this.props) === null || _b === void 0 ? void 0 : _b.changeViewName) === null || _c === void 0 ? void 0 : _c.call(_b, viewName, viewId))];
                    case 1:
                        _f.sent();
                        _f.label = 2;
                    case 2: return [3 /*break*/, 5];
                    case 3:
                        _a = _f.sent();
                        toast.error('Failed to change view name');
                        return [3 /*break*/, 5];
                    case 4:
                        (_e = (_d = this.props) === null || _d === void 0 ? void 0 : _d.clearCreatedNewViewData) === null || _e === void 0 ? void 0 : _e.call(_d);
                        return [7 /*endfinally*/];
                    case 5: return [2 /*return*/];
                }
            });
        }); };
        _this.onCreateNewCustomLogic = function (customLogic, edge) { return __awaiter(_this, void 0, void 0, function () {
            var _a;
            var _b, _c;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        if (customLogic === null || customLogic === void 0 ? void 0 : customLogic.x) {
                            customLogic.x = Math.round(customLogic.x);
                        }
                        if (customLogic === null || customLogic === void 0 ? void 0 : customLogic.y) {
                            customLogic.y = Math.round(customLogic.y);
                        }
                        _d.label = 1;
                    case 1:
                        _d.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.props.createNewCustomLogicWithPatch((_c = (_b = this.props) === null || _b === void 0 ? void 0 : _b.patchwork) === null || _c === void 0 ? void 0 : _c.patchwork.id, customLogic, edge)];
                    case 2:
                        _d.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        _a = _d.sent();
                        toast.error("Failed to create new  custom logic");
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        }); };
        _this.onChangeCustomLogicName = function (customLogicName, customLogicId, isCustomLogic) { return __awaiter(_this, void 0, void 0, function () {
            var _a;
            var _b, _c, _d, _e;
            return __generator(this, function (_f) {
                switch (_f.label) {
                    case 0:
                        _f.trys.push([0, 5, 6, 7]);
                        if (!(customLogicId && customLogicName)) return [3 /*break*/, 4];
                        if (!isCustomLogic) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.props.getAllCustomLogics()];
                    case 1:
                        _f.sent();
                        _f.label = 2;
                    case 2: return [4 /*yield*/, ((_c = (_b = this.props) === null || _b === void 0 ? void 0 : _b.changeCustomLogicName) === null || _c === void 0 ? void 0 : _c.call(_b, customLogicId, customLogicName))];
                    case 3:
                        _f.sent();
                        _f.label = 4;
                    case 4: return [3 /*break*/, 7];
                    case 5:
                        _a = _f.sent();
                        toast.error('Failed to change custom logic name');
                        return [3 /*break*/, 7];
                    case 6:
                        if (isCustomLogic)
                            (_e = (_d = this.props) === null || _d === void 0 ? void 0 : _d.clearCreatedCustomLogicData) === null || _e === void 0 ? void 0 : _e.call(_d);
                        return [7 /*endfinally*/];
                    case 7: return [2 /*return*/];
                }
            });
        }); };
        _this.onCreateCustomLogicPatchWithLogicPatches = function (patchName, logicPatches, outputs) { return __awaiter(_this, void 0, void 0, function () {
            var patchwork, patchworkId, connectedEdges, incomingEdge, params, inputValues, counter, key, valueObj;
            var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
            return __generator(this, function (_o) {
                switch (_o.label) {
                    case 0:
                        patchwork = ((_a = this.props) === null || _a === void 0 ? void 0 : _a.patchwork).patchwork;
                        if (!patchwork) return [3 /*break*/, 3];
                        patchworkId = patchwork === null || patchwork === void 0 ? void 0 : patchwork.id;
                        if (!patchworkId) return [3 /*break*/, 3];
                        connectedEdges = (_c = ((_b = patchwork === null || patchwork === void 0 ? void 0 : patchwork.edges) !== null && _b !== void 0 ? _b : [])) === null || _c === void 0 ? void 0 : _c.filter(function (edge) {
                            return logicPatches === null || logicPatches === void 0 ? void 0 : logicPatches.includes(edge.to_patch);
                        });
                        incomingEdge = (_d = (connectedEdges !== null && connectedEdges !== void 0 ? connectedEdges : [])) === null || _d === void 0 ? void 0 : _d.find(function (connectedEdge) { return !(logicPatches === null || logicPatches === void 0 ? void 0 : logicPatches.includes(connectedEdge.from_patch)); });
                        params = (_e = incomingEdge === null || incomingEdge === void 0 ? void 0 : incomingEdge.meta) === null || _e === void 0 ? void 0 : _e.params;
                        inputValues = [];
                        counter = 0;
                        for (key in params) {
                            if ((params === null || params === void 0 ? void 0 : params[key]) && key === ((_f = params[key]) === null || _f === void 0 ? void 0 : _f.sourceId)) {
                                valueObj = {
                                    //* Always replace the id's last char with index, since most of the time timestamp is same
                                    id: String("".concat(+new Date())).replace(/.$/, String("".concat(counter))),
                                    type: ((_g = params[key]) === null || _g === void 0 ? void 0 : _g.type)
                                        ? (_h = propertyMapper[params[key].type]) !== null && _h !== void 0 ? _h : params[key].type
                                        : 'text',
                                    description: '',
                                    required: true,
                                };
                                inputValues.push(__assign(__assign({}, valueObj), { name: key }));
                            }
                            counter++;
                        }
                        return [4 /*yield*/, this.props.createCustomLogicPatchWithLogicPatches(patchworkId, patchName, logicPatches, [{ name: 'in:__view__', type: 'event', value: inputValues }], outputs)];
                    case 1:
                        _o.sent();
                        //* This will close the selected logic group upon new custom logic creation
                        (_k = (_j = this.props) === null || _j === void 0 ? void 0 : _j.selectGroup) === null || _k === void 0 ? void 0 : _k.call(_j, null);
                        return [4 /*yield*/, ((_m = (_l = this.props) === null || _l === void 0 ? void 0 : _l.getPatchwork) === null || _m === void 0 ? void 0 : _m.call(_l))];
                    case 2:
                        _o.sent();
                        _o.label = 3;
                    case 3: return [2 /*return*/];
                }
            });
        }); };
        _this.onDuplicateBlock = function (node) {
            if (_this.handleOnSingleCopy(node))
                _this.handleOnPaste();
        };
        _this.onChangeViewName = function (viewName, viewId) { return __awaiter(_this, void 0, void 0, function () {
            var _a;
            var _b, _c, _d, _e;
            return __generator(this, function (_f) {
                switch (_f.label) {
                    case 0:
                        _f.trys.push([0, 3, 4, 5]);
                        if (!(viewId && viewName)) return [3 /*break*/, 2];
                        return [4 /*yield*/, ((_c = (_b = this.props) === null || _b === void 0 ? void 0 : _b.changeViewName) === null || _c === void 0 ? void 0 : _c.call(_b, viewName, viewId))];
                    case 1:
                        _f.sent();
                        _f.label = 2;
                    case 2: return [3 /*break*/, 5];
                    case 3:
                        _a = _f.sent();
                        toast.error('Failed to change view name');
                        return [3 /*break*/, 5];
                    case 4:
                        (_e = (_d = this.props) === null || _d === void 0 ? void 0 : _d.clearCreatedNewViewData) === null || _e === void 0 ? void 0 : _e.call(_d);
                        return [7 /*endfinally*/];
                    case 5: return [2 /*return*/];
                }
            });
        }); };
        _this.onRenamePatch = function (originalPatch, patchName, changes, isCustomLogicPatch) {
            _this.onPatchUpdate(__assign(__assign({}, originalPatch), changes));
            if (isCustomLogicPatch) {
                _this.props.onChangeCustomLogicName(patchName, originalPatch === null || originalPatch === void 0 ? void 0 : originalPatch.custom_logic, true);
            }
            else {
                _this.onChangeViewName(patchName, originalPatch === null || originalPatch === void 0 ? void 0 : originalPatch.view);
            }
        };
        _this.onChangePatchCoordinates = function (batch) {
            var _a, _b, _c, _d;
            var patchworkId = (_c = (_b = (_a = _this.props) === null || _a === void 0 ? void 0 : _a.patchwork) === null || _b === void 0 ? void 0 : _b.patchwork) === null || _c === void 0 ? void 0 : _c.id;
            if (patchworkId && batch) {
                (_d = _this.props) === null || _d === void 0 ? void 0 : _d.updatePatchCoordinates(patchworkId, batch);
            }
        };
        _this.renderPropertiesBar = function () {
            var propertiesBarView = _this.state.propertiesBarView;
            switch (propertiesBarView) {
                case 'patch':
                    return _this.renderPatchProperties();
                case 'edge':
                    return _this.renderEdgePropertiesMapper();
                default:
                    return _jsx(_Fragment, {});
            }
        };
        _this.setSelectedEntity = function (entity) {
            _this.setState({ selectedEntity: entity });
        };
        _this.state = {
            selectedEntity: null,
            propertiesBarView: 'empty',
            toDeleteEdges: [],
            canvasSelected: false,
            isFocused: false,
            structureBuilderLoadedOnce: false,
            platformsFetched: false,
            isSearchOpen: false,
            directedPatch: {
                label: '',
                value: '',
            },
            copyData: {},
            cursorPosition: {
                x: 0,
                y: 0,
            },
            directOnce: true,
            customLogicWarning: false,
            customLogicShow: false,
            entrypointWarningOpen: false,
            entryPatch: '',
            edges: [],
            matchingPatch: { label: '', value: '' },
        };
        _this.props.getPatchwork();
        _this.props.getAllCustomLogics();
        _this.props.getViews();
        _this.props.getDatasets();
        _this.props.getAppGroups();
        _this.props.getIcons();
        _this.props.loadStates();
        _this.props.loadStorage();
        _this.props.loadVariables();
        _this.props.loadEnv();
        _this.props.loadSelectedApp();
        _this.props.getPermissions();
        _this.props.fetchPushReceiverAppsGroups();
        _this.props.fetchPushTemplates();
        _this.container = React.createRef();
        return _this;
    }
    StructureBuilderPage.prototype.componentDidMount = function () {
        var _a;
        /*
        * This block of code decides whether structure builder is focused or not.
        * This is because structure builder is mounted to the base url where isExact is true, hence is not unmounting
        ! Whenever structure builder is detaching from the base url, this code snippet should be refactored accordingly
        */
        if ((_a = this.props) === null || _a === void 0 ? void 0 : _a.isExact) {
            this.setState({ isFocused: true });
        }
        window.addEventListener('click', this.handleClick);
    };
    StructureBuilderPage.prototype.componentWillUnmount = function () {
        window.removeEventListener('click', this.handleClick);
    };
    StructureBuilderPage.prototype.componentDidUpdate = function (prevProps, preState) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w;
        return __awaiter(this, void 0, void 0, function () {
            var _x, appId, reDirectPatchId, patchId, patchwork, _y, edges, _z, patches, logicGroups, _0, selectGroup, reSetFocalPatch, focalPatch, item, exsit, _1, getDatasetRows, viewState, customLogicSubscription, resetCustomLogicSubscription, pushTemplatesAppId, isGroupSelectedForFirstTime, isPatchesLoadingForFirstTime, subscribedCustomPatches, _i, _2, p;
            var _this = this;
            return __generator(this, function (_3) {
                switch (_3.label) {
                    case 0:
                        _x = this.props.params, appId = _x.appId, reDirectPatchId = _x.reDirectPatchId, patchId = _x.patchId;
                        patchwork = this.props.patchwork.patchwork;
                        _y = patchwork.edges, edges = _y === void 0 ? [] : _y, _z = patchwork.patches, patches = _z === void 0 ? [] : _z, logicGroups = patchwork.logicGroups;
                        _0 = this.props, selectGroup = _0.selectGroup, reSetFocalPatch = _0.reSetFocalPatch, focalPatch = _0.focalPatch;
                        if (focalPatch && preState.directedPatch.value !== focalPatch) {
                            this.setState({
                                directedPatch: {
                                    label: 'reDirectPatchId',
                                    value: focalPatch,
                                },
                                directOnce: true,
                            });
                            reSetFocalPatch();
                        }
                        if (patchId && preState.directedPatch.value !== patchId) {
                            this.setState({
                                directedPatch: {
                                    label: 'reDirectPatchId',
                                    value: patchId,
                                },
                                directOnce: true,
                            });
                            reSetFocalPatch();
                        }
                        if (preState.directedPatch.value === '' &&
                            (patches === null || patches === void 0 ? void 0 : patches.length) &&
                            preState.directedPatch.value !== reDirectPatchId &&
                            (reDirectPatchId === null || reDirectPatchId === void 0 ? void 0 : reDirectPatchId.length) === 19) {
                            for (item in logicGroups) {
                                exsit = (_b = (_a = logicGroups[item]) === null || _a === void 0 ? void 0 : _a.patches) === null || _b === void 0 ? void 0 : _b.some(function (i) { return i.id === reDirectPatchId; });
                                if (exsit) {
                                    selectGroup(item);
                                    break;
                                }
                            }
                            this.setState({
                                directedPatch: {
                                    label: 'reDirectPatchId',
                                    value: reDirectPatchId,
                                },
                            });
                            if (this.onPatchSearchSelect) {
                                this.onPatchSearchSelect(reDirectPatchId);
                            }
                        }
                        if (!this.state.isFocused && this.state.selectedEntity) {
                            this.setState({ selectedEntity: null });
                        }
                        _1 = this.props, getDatasetRows = _1.getDatasetRows, viewState = _1.viewState, customLogicSubscription = _1.customLogicSubscription, resetCustomLogicSubscription = _1.resetCustomLogicSubscription, pushTemplatesAppId = _1.pushTemplatesAppId;
                        if (this.props.isExact !== prevProps.isExact &&
                            this.props.isExact &&
                            this.props.selectedApp.app.style !== undefined) {
                            this.props.loadSelectedApp();
                        }
                        if (!((_c = prevProps.permissions["app:".concat(appId, ":styles")]) === null || _c === void 0 ? void 0 : _c.includes("read")) ||
                            prevProps.selectedApp.app.style === undefined || //on reload
                            prevProps.selectedApp.app.style !== this.props.selectedApp.app.style //on change
                        ) {
                            ((_d = this.props.permissions["app:".concat(appId, ":styles")]) === null || _d === void 0 ? void 0 : _d.includes("read")) &&
                                this.props.selectedApp.app.style !== undefined &&
                                this.props.selectedApp.app.style !== null &&
                                this.props.getStyle(this.props.selectedApp.app.style);
                        }
                        if (!(((_e = this.props) === null || _e === void 0 ? void 0 : _e.outputParamSync) &&
                            !isEqual(prevProps === null || prevProps === void 0 ? void 0 : prevProps.outputParamSync, this.props.outputParamSync))) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.syncSelectedEdgesWithCustomLogicChanges(patches, edges, this.props.outputParamSync)];
                    case 1:
                        _3.sent();
                        _3.label = 2;
                    case 2:
                        isGroupSelectedForFirstTime = !((_g = (_f = prevProps === null || prevProps === void 0 ? void 0 : prevProps.patchwork) === null || _f === void 0 ? void 0 : _f.patchwork) === null || _g === void 0 ? void 0 : _g.group) && (patchwork === null || patchwork === void 0 ? void 0 : patchwork.group) !== null;
                        isPatchesLoadingForFirstTime = !((_k = (_j = (_h = prevProps === null || prevProps === void 0 ? void 0 : prevProps.patchwork) === null || _h === void 0 ? void 0 : _h.patchwork) === null || _j === void 0 ? void 0 : _j.patches) === null || _k === void 0 ? void 0 : _k.length) &&
                            (patches === null || patches === void 0 ? void 0 : patches.length) &&
                            prevProps.viewState === 'loading' &&
                            viewState === 'normal';
                        /**
                         * When app is loading for the first time, this code snippet go through all the custom logic patches,
                         * if there's a custom logic patch without missing_params prop, it gets updated
                         */
                        if (isPatchesLoadingForFirstTime || isGroupSelectedForFirstTime) {
                            this.updateCustomLogicPatchesWithRequiredInputs(null, isGroupSelectedForFirstTime);
                        }
                        if (!(customLogicSubscription &&
                            (customLogicSubscription === null || customLogicSubscription === void 0 ? void 0 : customLogicSubscription.type) === CUSTOM_LOGIC_SUBSCRIPTION_TYPE.ARG)) return [3 /*break*/, 4];
                        subscribedCustomPatches = patches === null || patches === void 0 ? void 0 : patches.filter(function (patch) {
                            return (patch === null || patch === void 0 ? void 0 : patch.custom_logic) === customLogicSubscription.ref &&
                                Object.hasOwn(patch === null || patch === void 0 ? void 0 : patch.settings, 'missing_params');
                        });
                        if (subscribedCustomPatches === null || subscribedCustomPatches === void 0 ? void 0 : subscribedCustomPatches.length) {
                            subscribedCustomPatches === null || subscribedCustomPatches === void 0 ? void 0 : subscribedCustomPatches.forEach(function (patch) {
                                _this.updateMissingParamsPropInCustomLogicPatchSettings(patch);
                            });
                        }
                        return [4 /*yield*/, resetCustomLogicSubscription()];
                    case 3:
                        _3.sent();
                        _3.label = 4;
                    case 4:
                        if (!(patchwork && patchwork.id !== prevProps.patchwork.patchwork.id)) return [3 /*break*/, 10];
                        _i = 0, _2 = patchwork.patches;
                        _3.label = 5;
                    case 5:
                        if (!(_i < _2.length)) return [3 /*break*/, 8];
                        p = _2[_i];
                        if (!(p.type === 'dataset')) return [3 /*break*/, 7];
                        return [4 /*yield*/, getDatasetRows(p.dataset)];
                    case 6:
                        _3.sent();
                        _3.label = 7;
                    case 7:
                        _i++;
                        return [3 /*break*/, 5];
                    case 8:
                        if (!((_l = patchwork === null || patchwork === void 0 ? void 0 : patchwork.patches) === null || _l === void 0 ? void 0 : _l.find(function (p) { return p.logic === 'push_send' || p.logic === 'deep_linked_push_send'; }))) return [3 /*break*/, 10];
                        return [4 /*yield*/, this.checkPlatforms()];
                    case 9:
                        _3.sent();
                        _3.label = 10;
                    case 10:
                        /*
                        * This block of code decides whether structure builder is focused or not.
                        * This is because structure builder is mounted to the base url where isExact is true, hence is not unmounting
                        ! Whenever structure builder is detaching from the base url, this code snippet should be refactored accordingly
                        */
                        if (!(prevProps === null || prevProps === void 0 ? void 0 : prevProps.isExact) && ((_m = this.props) === null || _m === void 0 ? void 0 : _m.isExact)) {
                            this.setState({ isFocused: true });
                            if (!customLogicSubscription)
                                (_p = (_o = this.props) === null || _o === void 0 ? void 0 : _o.refreshPatchwork) === null || _p === void 0 ? void 0 : _p.call(_o);
                            this.setState({ selectedEntity: null });
                        }
                        else if ((prevProps === null || prevProps === void 0 ? void 0 : prevProps.isExact) && !((_q = this.props) === null || _q === void 0 ? void 0 : _q.isExact)) {
                            this.setState({ isFocused: false });
                        }
                        if (((_r = prevProps.patchwork.patchwork) === null || _r === void 0 ? void 0 : _r.group) && !(patchwork === null || patchwork === void 0 ? void 0 : patchwork.group)) {
                            this.setState({ selectedEntity: null });
                        }
                        // This is to update any navigation type patch if an edge is created
                        // and connected to an output
                        if (((_u = (_t = (_s = prevProps === null || prevProps === void 0 ? void 0 : prevProps.patchwork) === null || _s === void 0 ? void 0 : _s.patchwork) === null || _t === void 0 ? void 0 : _t.edges) === null || _u === void 0 ? void 0 : _u.length) !== edges.length &&
                            edges.length !== 0) {
                            patches.forEach(function (patch) {
                                if (patch.type === 'navigation') {
                                    edges.forEach(function (edge) {
                                        var _a, _b;
                                        if (edge.from_patch === patch.id) {
                                            if (edge.from_arg === 'out:__menuItem__') {
                                                if (!patch.settings.items) {
                                                    _this.onPatchUpdate(__assign(__assign({}, patch), { settings: __assign(__assign({}, patch.settings), { items: [edge.id] }) }));
                                                }
                                                else if ((patch === null || patch === void 0 ? void 0 : patch.settings.items) &&
                                                    !((_a = patch === null || patch === void 0 ? void 0 : patch.settings.items) === null || _a === void 0 ? void 0 : _a.includes(edge.id))) {
                                                    _this.onPatchUpdate(__assign(__assign({}, patch), { settings: __assign(__assign({}, patch.settings), { items: __spreadArray(__spreadArray([], patch === null || patch === void 0 ? void 0 : patch.settings.items, true), [edge.id], false) }) }));
                                                }
                                            }
                                            else if (edge.from_arg === 'out:__contextItem__') {
                                                if (!patch.settings.contextItems) {
                                                    _this.onPatchUpdate(__assign(__assign({}, patch), { settings: __assign(__assign({}, patch.settings), { contextItems: [edge.id] }) }));
                                                }
                                                else if ((patch === null || patch === void 0 ? void 0 : patch.settings.contextItems) &&
                                                    !((_b = patch === null || patch === void 0 ? void 0 : patch.settings.contextItems) === null || _b === void 0 ? void 0 : _b.includes(edge.id))) {
                                                    _this.onPatchUpdate(__assign(__assign({}, patch), { settings: __assign(__assign({}, patch.settings), { contextItems: __spreadArray(__spreadArray([], patch === null || patch === void 0 ? void 0 : patch.settings.contextItems, true), [edge.id], false) }) }));
                                                }
                                            }
                                        }
                                    });
                                }
                            });
                        }
                        this.props.viewState === 'normal' &&
                            !this.state.structureBuilderLoadedOnce &&
                            this.setState({
                                structureBuilderLoadedOnce: true,
                            });
                        if (!((_v = prevProps.permissions["app:".concat(appId, ":integrations")]) === null || _v === void 0 ? void 0 : _v.includes("read")) &&
                            this.props.permissions &&
                            ((_w = this.props.permissions["app:".concat(appId, ":integrations")]) === null || _w === void 0 ? void 0 : _w.includes("read"))) {
                            this.props.getIntegrations();
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    StructureBuilderPage.prototype.getVanityPorts = function (ports) {
        return ports.filter(function (port) { return port.type !== 'event'; });
    };
    StructureBuilderPage.prototype.render = function () {
        var _this = this;
        var _a;
        var _b = this.props, selectGroup = _b.selectGroup, getPatchwork = _b.getPatchwork, permissions = _b.permissions, location = _b.location, customLogics = _b.customLogics, customLogicSubscription = _b.customLogicSubscription, pushTemplates = _b.pushTemplates, patchesConnectedToHome = _b.patchesConnectedToHome;
        var _c = this.props.patchwork, _d = _c.patchwork, patchwork = _d === void 0 ? {} : _d, views = _c.views, datasets = _c.datasets, _e = _c.integrations, integrations = _e === void 0 ? [] : _e;
        var groupSelected = (patchwork === null || patchwork === void 0 ? void 0 : patchwork.group) !== null;
        var _f = this.state, propertiesBarView = _f.propertiesBarView, selectedEntity = _f.selectedEntity, edges = _f.edges, isFocused = _f.isFocused;
        var _g = this.props.params, appId = _g.appId, organizationId = _g.organizationId;
        if (!patchwork) {
            return null;
        }
        var isLogicGroup = (selectedEntity === null || selectedEntity === void 0 ? void 0 : selectedEntity.patchType) === 'logic_group';
        return (_jsxs(_Fragment, { children: [_jsx(SetEntrypointWarning, { entrypointWarningOpen: this.state.entrypointWarningOpen, setEntrypointWarningOpen: function (isOpen) {
                        return _this.setState({
                            entrypointWarningOpen: isOpen,
                        });
                    }, setEntrypoint: function () { return _this.setEntrypoint(_this.state.entryPatch); }, count: pushTemplates === null || pushTemplates === void 0 ? void 0 : pushTemplates.length }), location.pathname ===
                    "/organizations/".concat(organizationId, "/apps/").concat(appId) && (_jsx(Helmet, { children: _jsx("title", { children: "Structure Builder" }) })), !this.state.structureBuilderLoadedOnce && (_jsx(PageLoaderContainer, { children: _jsx(FontAwesomeIcon, { icon: faSpinner, spin: true, size: "lg", color: "#858585" }) })), _jsxs(CommonModal, __assign({ active: this.state.customLogicWarning, hideModal: function () {
                        _this.setState({
                            customLogicWarning: false,
                        });
                    }, title: "Copying Custom Logic", modalType: "create", cancel: "Dismiss", action: "Copy", width: '560px', height: '600px', disabled: false, tooltip: 'Duplicate your app quickly with the Clone App feature for rapid project iteration and customization', onClick: function () { return __awaiter(_this, void 0, void 0, function () {
                        var successFlag;
                        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s;
                        return __generator(this, function (_t) {
                            switch (_t.label) {
                                case 0:
                                    if (!this.state.customLogicShow) return [3 /*break*/, 2];
                                    return [4 /*yield*/, localStorage.setItem(PATCH_COPY_TYPE.WARN, JSON.stringify({
                                            customWarning: true,
                                        }))];
                                case 1:
                                    _t.sent();
                                    _t.label = 2;
                                case 2:
                                    if (!(((_c = (_b = (_a = this.state) === null || _a === void 0 ? void 0 : _a.copyData) === null || _b === void 0 ? void 0 : _b.firstPatch) === null || _c === void 0 ? void 0 : _c.id) ||
                                        ((_f = (_e = (_d = this.state) === null || _d === void 0 ? void 0 : _d.copyData) === null || _e === void 0 ? void 0 : _e.patchIds) === null || _f === void 0 ? void 0 : _f.length) ||
                                        ((_j = (_h = (_g = this.state) === null || _g === void 0 ? void 0 : _g.copyData) === null || _h === void 0 ? void 0 : _h.groupIds) === null || _j === void 0 ? void 0 : _j.length))) return [3 /*break*/, 4];
                                    return [4 /*yield*/, this.handleOnBulkCopy((_l = (_k = this.state) === null || _k === void 0 ? void 0 : _k.copyData) === null || _l === void 0 ? void 0 : _l.firstPatch, (_o = (_m = this.state) === null || _m === void 0 ? void 0 : _m.copyData) === null || _o === void 0 ? void 0 : _o.patchIds, (_q = (_p = this.state) === null || _p === void 0 ? void 0 : _p.copyData) === null || _q === void 0 ? void 0 : _q.groupIds, (_s = (_r = this.state) === null || _r === void 0 ? void 0 : _r.copyData) === null || _s === void 0 ? void 0 : _s.customLogic)];
                                case 3:
                                    successFlag = _t.sent();
                                    successFlag
                                        ? toast.success("Copied the selection successfully")
                                        : toast.error("Failed to copy the selection");
                                    return [3 /*break*/, 5];
                                case 4:
                                    toast.error("Failed to copy the selection");
                                    _t.label = 5;
                                case 5:
                                    this.setState({
                                        customLogicWarning: false,
                                    });
                                    return [2 /*return*/];
                            }
                        });
                    }); } }, { children: [_jsx("p", { children: "You cannot copy and paste custom logic outside of the app. Please ensure you are copying and pasting within the app." }), _jsxs(CheckboxWrapper, { children: [_jsx("input", { disabled: false, type: "checkbox", checked: this.state.customLogicShow, onClick: function () {
                                        _this.setState({
                                            customLogicShow: !_this.state.customLogicShow,
                                        });
                                    } }), _jsx(DescriptionText, { children: "Don\u2019t show me again" })] })] })), _jsx(PageContent, { children: _jsxs(Wrapper, __assign({ ref: this.container }, { children: [_jsx(AddPatchModal, { views: views, customLogics: customLogics, datasets: datasets, integrations: integrations, patchFilter: groupSelected ? ['logic', 'integration'] : [], onSave: this.onCreatePatch, onCreateNewView: function (view, edge) { return _this.onCreateNewView(view, edge); }, onCreateNewCustomLogic: function (customLogic, edge) {
                                    return _this.onCreateNewCustomLogic(customLogic, edge);
                                }, isOpen: true, onClose: function () { return null; } }), _jsx(ReactFlowProvider, { children: _jsx(Graph, { appId: appId, onPatchAddNewEvent: this.onPatchAddNewEvent, onDuplicateBlock: this.onDuplicateBlock, onRenamePatch: this.onRenamePatch, onSetEntrypoint: this.onSetEntrypoint, selectGroup: selectGroup, edges: edges, patchwork: patchwork, permissions: (_a = permissions === null || permissions === void 0 ? void 0 : permissions["app:".concat(appId, ":patchwork")]) !== null && _a !== void 0 ? _a : [], 
                                    //Patch Operations
                                    onPatchSelected: this.onPatchSelected, onPatchDelete: this.onPatchDelete, 
                                    // Edge Operations
                                    onEdgeAdded: this.onEdgeAdded, onEdgeSelected: this.onEdgeSelected, onEdgeDelete: this.onEdgeDelete, 
                                    // Patch Selection & Copy related props
                                    onDeselect: this.onDeselect, onCopy: this.handleOnCopy, onPaste: this.handleOnPaste, 
                                    // Other Operations
                                    onRefreshPatchwork: getPatchwork, pushTemplates: pushTemplates, patchesConnectedToHome: patchesConnectedToHome, groupSelected: groupSelected, openGroup: selectGroup, onCreateCustomLogicPatchWithLogicPatches: this.onCreateCustomLogicPatchWithLogicPatches, selectedEntity: selectedEntity, isFocused: isFocused, onChangePatchCoordinates: this.onChangePatchCoordinates, onCursorPosition: this.onCursorPosition, focusEntityId: this.props.params.patchId }) }), propertiesBarView !== 'empty' &&
                                patchwork &&
                                selectedEntity &&
                                !customLogicSubscription &&
                                !isLogicGroup ? (_jsx(PropertiesBar, __assign({ patchwork: true }, { children: this.renderPropertiesBar() }))) : null] })) })] }));
    };
    return StructureBuilderPage;
}(React.Component));
export { StructureBuilderPage };
var mapStateToProps = function () {
    return createStructuredSelector({
        permissions: selectPermissions,
        patchwork: selectStructure,
        customLogics: selectAllCustomLogics,
        loaders: selectLoaders,
        canvasOffset: selectCanvasOffset,
        states: selectState,
        globalStorage: selectStorage,
        platforms: selectPlatformDomain,
        viewState: selectViewState,
        variables: selectVariable,
        environments: selectEnvironments,
        datasetRules: selectDatasetRules,
        datasetRulesLoading: selectDatasetRulesLoading,
        datasetNewRuleId: selectDatasetNewRuleId,
        datasetRuleGroups: selectGroupDropdownOptions,
        rulesDatasetId: selectDatasetRulesDatasetId,
        createdView: selectCreatedView,
        createdCustomLogic: selectCustomLogicCreateData,
        tempNewPatch: selectTempNewPatch,
        styles: makeSelectStyle,
        selectedApp: selectSelectedApp,
        currentStyle: selectGlobalStyles,
        outputParamSync: selectOutputParamSync,
        customLogicSubscription: selectCustomLogicSubscription,
        globalStyles: selectGlobalStyles,
        focalPatch: selectFocalPatch,
        pushTemplatesAppId: makeSelectPushTemplatesAppId,
        patchesConnectedToHome: selectPatchesDropDown,
        pushTemplates: makeSelectPushTemplates,
        receiverApps: selectReceiverApps,
        openGroup: selectSelectedGroup,
    });
};
var mapDispatchToProps = function (dispatch, ownProps) {
    var _a = ownProps.params, appId = _a.appId, organizationId = _a.organizationId;
    return {
        cloneMonoPatch: function (copiedItemArray) {
            dispatch(actions.cloneMonoPatch(copiedItemArray));
        },
        clonePolyPatch: function (copiedItemArray) {
            dispatch(actions.clonePolyPatch(copiedItemArray));
        },
        reSetFocalPatch: function () {
            dispatch(actions.reSetFocalPatch());
        },
        updateCanvasOffset: function (canvasOffset) {
            dispatch(actions.updateCanvasOffset(canvasOffset));
        },
        getDatasetRows: function (datasetId) {
            dispatch(actions.getDatasetRows(datasetId));
        },
        getDatasetRule: function (datasetId) {
            dispatch(datasetRulesActions.loadDatasetRules(datasetId, appId));
        },
        createDatasetRule: function (datasetId, rule, appId) {
            return dispatch(datasetRulesActions.createDatasetRule(datasetId, rule, appId));
        },
        getDatasetPermissionGroup: function () {
            dispatch(datasetRulesActions.loadGroups(appId));
        },
        getPatchwork: function () { return dispatch(actions.getPatchwork(appId)); },
        refreshPatchwork: function () { return dispatch(actions.getPatchwork(appId, true)); },
        getAllCustomLogics: function () {
            return dispatch(logicBuilderActions.customLogicReadAllAction(appId));
        },
        getAppGroups: function () {
            dispatch(actions.getAppGroups(appId));
        },
        updatePatchwork: function (patchworkId, patchwork) {
            return dispatch(actions.updatePatchwork(patchworkId, patchwork));
        },
        getViews: function () {
            dispatch(actions.getViews(appId));
        },
        getDatasets: function (fetchAll) {
            if (fetchAll === void 0) { fetchAll = false; }
            dispatch(actions.getDatasets(!fetchAll ? appId : null));
        },
        createPatch: function (patchworkId, patch) {
            return dispatch(actions.createPatch(patchworkId, patch));
        },
        deletePatch: function (patchworkId, patchId) {
            return dispatch(actions.deletePatch(appId, patchworkId, patchId));
        },
        deletePatches: function (patchworkId, patches) {
            return dispatch(actions.deletePatches(appId, patchworkId, patches));
        },
        createEdge: function (patchworkId, edge) {
            return dispatch(actions.createEdge(patchworkId, edge));
        },
        updateEdge: function (patchworkId, edgeId, edge) {
            dispatch(actions.updateEdge(patchworkId, edgeId, edge));
        },
        deleteEdge: function (patchworkId, edgeId, checkMissingParams) {
            return dispatch(actions.deleteEdge(patchworkId, edgeId, checkMissingParams));
        },
        updatePatch: function (patchworkId, patch) {
            dispatch(actions.updatePatch(patchworkId, patch.id, patch));
        },
        goToPermissions: function (patchworkId, patchId) {
            ownProps.navigate("/organizations/".concat(organizationId, "/apps/").concat(appId, "/patchwork/").concat(patchworkId, "/").concat(patchId, "/permissions"));
        },
        goToViewPage: function (viewId) {
            return ownProps.navigate("/organizations/".concat(organizationId, "/apps/").concat(appId, "/views/").concat(viewId));
        },
        goToPlatformPage: function () {
            return ownProps.navigate("/organizations/".concat(organizationId, "/apps/").concat(appId, "/configuration"));
        },
        getIcons: function () {
            dispatch(actions.getIcons("app:".concat(appId)));
        },
        setLoadingState: function () { return dispatch(actions.setLoadingState()); },
        getIntegrations: function (fetchAll) {
            if (fetchAll === void 0) { fetchAll = false; }
            return dispatch(actions.getIntegrations(!fetchAll ? appId : null));
        },
        getPermissions: function () {
            return dispatch(getPermissionsByTargets([
                "app:".concat(appId, ":integrations"),
                "app:".concat(appId, ":styles"),
            ]));
        },
        loadStates: function () { return dispatch(stateActions.loadStates(appId)); },
        loadStorage: function () { return dispatch(globalStorageActions.loadStorage(appId)); },
        loadVariables: function () { return dispatch(variableActions.loadVariables(appId)); },
        loadEnv: function () { return dispatch(envActions.loadEnvironment(appId)); },
        fetchSubdomain: function () { return dispatch(platformActions.fetchSubdomain(appId)); },
        checkFirebaseIOSApp: function () {
            return dispatch(platformActions.checkFirebaseIOSApp(appId));
        },
        checkFirebaseAndroidApp: function () {
            return dispatch(platformActions.checkFirebaseAndroidApp(appId));
        },
        selectGroup: function (patchId) { return dispatch(actions.selectGroup(patchId)); },
        loadApps: function () { return dispatch(loadApps()); },
        getStyle: function (styleId) { return dispatch(viewBuilderActions.getStyle(styleId)); },
        loadSelectedApp: function () { return dispatch(loadSelectedApp(appId)); },
        createView: function (view) { return dispatch(actions.createView(view, appId)); },
        clearCreatedNewViewData: function () { return dispatch(actions.clearCreatedNewViewData); },
        createViewEvent: function (eventName, viewId) {
            return dispatch(actions.createViewEvent(eventName, viewId));
        },
        changeViewName: function (viewName, viewId) {
            return dispatch(actions.updateViewName(viewName, viewId));
        },
        createCustomLogic: function (customLogicName) {
            return dispatch(logicBuilderActions.customLogicCreateAction(appId, customLogicName));
        },
        changeCustomLogicName: function (customLogicId, customLogicName) {
            return dispatch(logicBuilderActions.customLogicRenameAction(customLogicId, customLogicName));
        },
        clearCreatedCustomLogicData: function () {
            return dispatch(logicBuilderActions.resetCustomLogicCreateStateAction);
        },
        createNewCustomLogicWithPatch: function (patchworkId, patch, edge) {
            dispatch(actions.createNewCustomLogicWithPatch(appId, patchworkId, patch, edge));
        },
        createCustomLogicPatchWithLogicPatches: function (patchworkId, patchName, logicPatches, inputs, outputs) {
            dispatch(actions.createCustomLogicPatchWithLogicPatches(appId, patchworkId, patchName, logicPatches, inputs, outputs));
        },
        resetOutputParamSync: function () {
            dispatch(updateOutputParamSync(null));
        },
        updatePatchCoordinates: function (patchworkId, batch) {
            dispatch(actions.updatePatchCoordinates(patchworkId, batch));
        },
        resetCustomLogicSubscription: function () {
            dispatch(setCustomLogicSubscription(null));
        },
        fetchPushTemplates: function () { return dispatch(loadPushTemplates(appId)); },
        fetchPushReceiverAppsGroups: function () {
            dispatch(clearReceiverApps);
            dispatch(loadPushReceiverAppsGroups(appId));
        },
    };
};
var withConnect = connect(mapStateToProps, mapDispatchToProps);
var ConnectedStructureBuilderPage = compose(withConnect)(StructureBuilderPage);
export default StructureBuilderPageWrapper;
